/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
//     SourceSHA: 
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { TellerOnlineApiClientBase } from 'libraries/core/src/lib/api/apiClientBase';
import { TellerOnlineWindowService } from 'libraries/shared/src/lib/services/window.service';
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, from as _observableFrom, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const PAYMENT_INTEGRATIONS_API_BASE_URL = new InjectionToken<string>('PAYMENT_INTEGRATIONS_API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class SharedPaymentIntegrationApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return SharedPaymentIntegrationApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(PAYMENT_INTEGRATIONS_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) SharedPaymentIntegrationApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/payment-integrations";
    }

    static init(baseUrl: string){
        SharedPaymentIntegrationApiClient._baseUrl = baseUrl;
    }

    /**
     * @return OK
     */
    getConfig(): Observable<PaymentConfigResponseDto> {
        let url_ = this.baseUrl + "/config";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetConfig(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetConfig(<any>r));
                } catch (e) {
                    return <Observable<PaymentConfigResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<PaymentConfigResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetConfig(response: HttpResponseBase): Observable<PaymentConfigResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PaymentConfigResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Retrieve a hash value of this cart to determine if it has been modified in the context of what's sent to the payment processor
     * @param paymentMethodType The payment method being used
     * @param cartGuid Unique GUID of cart
     * @param paymentIdentifier (optional) Unique payment identifier for this cart to use in the hashing check
     * @return OK
     */
    getCartHash(paymentMethodType: string, cartGuid: string, paymentIdentifier?: string | null | undefined): Observable<string> {
        let url_ = this.baseUrl + "/cart-hash/{CartGuid}/{PaymentMethodType}?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentMethodType === undefined || paymentMethodType === null)
            throw new Error("The parameter 'paymentMethodType' must be defined.");
        url_ = url_.replace("{PaymentMethodType}", encodeURIComponent("" + paymentMethodType));
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        if (paymentIdentifier !== undefined && paymentIdentifier !== null)
            url_ += "PaymentIdentifier=" + encodeURIComponent("" + paymentIdentifier) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetCartHash(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetCartHash(<any>r));
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetCartHash(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : _responseText;
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    verifyPaymentStatus(body: RedirectVerifyPaymentStatusRequestDto): Observable<RedirectVerifyPaymentStatusResponseDto> {
        let url_ = this.baseUrl + "/verifyPaymentStatus";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processVerifyPaymentStatus(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processVerifyPaymentStatus(<any>r));
                } catch (e) {
                    return <Observable<RedirectVerifyPaymentStatusResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<RedirectVerifyPaymentStatusResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processVerifyPaymentStatus(response: HttpResponseBase): Observable<RedirectVerifyPaymentStatusResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RedirectVerifyPaymentStatusResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cartGuid Unique identifier for the cart
     * @param paymentStatus (optional) Desired status of the returned payment
     * @param inboundRedirectSourceId (optional) The ID of the inbound redirect source where the request was initiated, if any.
     * @return OK
     */
    startPayment(cartGuid: string, paymentStatus?: PaymentStatusEnumDto | undefined, inboundRedirectSourceId?: number | undefined): Observable<StartPaymentResponseDto> {
        let url_ = this.baseUrl + "/start-payment/{CartGuid}?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        if (paymentStatus === null)
            throw new Error("The parameter 'paymentStatus' cannot be null.");
        else if (paymentStatus !== undefined)
            url_ += "PaymentStatus=" + encodeURIComponent("" + paymentStatus) + "&";
        if (inboundRedirectSourceId === null)
            throw new Error("The parameter 'inboundRedirectSourceId' cannot be null.");
        else if (inboundRedirectSourceId !== undefined)
            url_ += "InboundRedirectSourceId=" + encodeURIComponent("" + inboundRedirectSourceId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processStartPayment(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processStartPayment(<any>r));
                } catch (e) {
                    return <Observable<StartPaymentResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<StartPaymentResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processStartPayment(response: HttpResponseBase): Observable<StartPaymentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartPaymentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    makePayment(body: IFramePaymentRequestDto): Observable<IFramePaymentResponseDto> {
        let url_ = this.baseUrl + "/payment";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processMakePayment(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processMakePayment(<any>r));
                } catch (e) {
                    return <Observable<IFramePaymentResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IFramePaymentResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processMakePayment(response: HttpResponseBase): Observable<IFramePaymentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IFramePaymentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param paymentMethodId Unique ID of the payment method to update
     * @return OK
     */
    updatePaymentMethod(paymentMethodId: number, body: IFrameSavePaymentMethodRequestDto): Observable<IFrameSavePaymentMethodResponseDto> {
        let url_ = this.baseUrl + "/update-payment-method/{PaymentMethodId}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentMethodId === undefined || paymentMethodId === null)
            throw new Error("The parameter 'paymentMethodId' must be defined.");
        url_ = url_.replace("{PaymentMethodId}", encodeURIComponent("" + paymentMethodId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processUpdatePaymentMethod(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processUpdatePaymentMethod(<any>r));
                } catch (e) {
                    return <Observable<IFrameSavePaymentMethodResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IFrameSavePaymentMethodResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processUpdatePaymentMethod(response: HttpResponseBase): Observable<IFrameSavePaymentMethodResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IFrameSavePaymentMethodResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    addPaymentMethod(body: IFrameSavePaymentMethodRequestDto): Observable<IFrameSavePaymentMethodResponseDto> {
        let url_ = this.baseUrl + "/add-payment-method";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processAddPaymentMethod(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processAddPaymentMethod(<any>r));
                } catch (e) {
                    return <Observable<IFrameSavePaymentMethodResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IFrameSavePaymentMethodResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processAddPaymentMethod(response: HttpResponseBase): Observable<IFrameSavePaymentMethodResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IFrameSavePaymentMethodResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cartGuid Unique GUID of cart
     * @param paymentMethodType The payment method being used
     * @return OK
     */
    calculateConvenienceFee(cartGuid: string, paymentMethodType: string): Observable<ConvenienceFeeResponseDto> {
        let url_ = this.baseUrl + "/convenience-fee/{CartGuid}/{PaymentMethodType}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        if (paymentMethodType === undefined || paymentMethodType === null)
            throw new Error("The parameter 'paymentMethodType' must be defined.");
        url_ = url_.replace("{PaymentMethodType}", encodeURIComponent("" + paymentMethodType));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processCalculateConvenienceFee(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processCalculateConvenienceFee(<any>r));
                } catch (e) {
                    return <Observable<ConvenienceFeeResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ConvenienceFeeResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processCalculateConvenienceFee(response: HttpResponseBase): Observable<ConvenienceFeeResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ConvenienceFeeResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cartGuid Unique GUID of cart
     * @return OK
     */
    getAvailablePaymentMethods(cartGuid: string): Observable<AvailablePaymentMethodsResponseDto> {
        let url_ = this.baseUrl + "/available-payment-methods/{CartGuid}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetAvailablePaymentMethods(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetAvailablePaymentMethods(<any>r));
                } catch (e) {
                    return <Observable<AvailablePaymentMethodsResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<AvailablePaymentMethodsResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetAvailablePaymentMethods(response: HttpResponseBase): Observable<AvailablePaymentMethodsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AvailablePaymentMethodsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cartGuid Unique Identifier for the cart
     * @return OK
     */
    getRedirectUrl(cartGuid: string): Observable<string> {
        let url_ = this.baseUrl + "/getRedirectUrl/{CartGuid}";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{CartGuid}", encodeURIComponent("" + cartGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "text/plain"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetRedirectUrl(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetRedirectUrl(<any>r));
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processGetRedirectUrl(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : _responseText;
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class NicIntegrationApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return NicIntegrationApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(PAYMENT_INTEGRATIONS_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) NicIntegrationApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/payment-integrations";
    }

    static init(baseUrl: string){
        NicIntegrationApiClient._baseUrl = baseUrl;
    }

    /**
     * @return OK
     */
    nicVerifyPaymentStatus(body: NicVerifyPaymentStatusRequestDto): Observable<NicVerifyPaymentStatusResponseDto> {
        let url_ = this.baseUrl + "/nic/verifyPaymentStatus";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processNicVerifyPaymentStatus(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processNicVerifyPaymentStatus(<any>r));
                } catch (e) {
                    return <Observable<NicVerifyPaymentStatusResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<NicVerifyPaymentStatusResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processNicVerifyPaymentStatus(response: HttpResponseBase): Observable<NicVerifyPaymentStatusResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = NicVerifyPaymentStatusResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ElavonIntegrationApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return ElavonIntegrationApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(PAYMENT_INTEGRATIONS_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) ElavonIntegrationApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/payment-integrations";
    }

    static init(baseUrl: string){
        ElavonIntegrationApiClient._baseUrl = baseUrl;
    }

    /**
     * @return OK
     */
    requestSessionToken(): Observable<SessionTokenResponseDto> {
        let url_ = this.baseUrl + "/elavon/requestSessionToken";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRequestSessionToken(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRequestSessionToken(<any>r));
                } catch (e) {
                    return <Observable<SessionTokenResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SessionTokenResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processRequestSessionToken(response: HttpResponseBase): Observable<SessionTokenResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionTokenResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CyberSourceIntegrationApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return CyberSourceIntegrationApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(PAYMENT_INTEGRATIONS_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) CyberSourceIntegrationApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/payment-integrations";
    }

    static init(baseUrl: string){
        CyberSourceIntegrationApiClient._baseUrl = baseUrl;
    }

    /**
     * @return OK
     */
    getSessionToken(): Observable<SessionTokenResponseDto> {
        let url_ = this.baseUrl + "/cyber-source/requestSessionToken";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetSessionToken(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetSessionToken(<any>r));
                } catch (e) {
                    return <Observable<SessionTokenResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SessionTokenResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetSessionToken(response: HttpResponseBase): Observable<SessionTokenResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionTokenResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GenericIntegrationApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return GenericIntegrationApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(PAYMENT_INTEGRATIONS_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) GenericIntegrationApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/payment-integrations";
    }

    static init(baseUrl: string){
        GenericIntegrationApiClient._baseUrl = baseUrl;
    }

    /**
     * @return OK
     */
    genericPreparePaymentAndAssessFees(body: IFramePaymentRequestDto): Observable<IFramePaymentPrepareResponseDto> {
        let url_ = this.baseUrl + "/generic/preparePaymentAndAssessFees";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGenericPreparePaymentAndAssessFees(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGenericPreparePaymentAndAssessFees(<any>r));
                } catch (e) {
                    return <Observable<IFramePaymentPrepareResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IFramePaymentPrepareResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenericPreparePaymentAndAssessFees(response: HttpResponseBase): Observable<IFramePaymentPrepareResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IFramePaymentPrepareResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    genericReTokenizeSavedPaymentMethod(body: ReTokenizeSavedPaymentMethodRequestDto): Observable<IFramePaymentPrepareResponseDto> {
        let url_ = this.baseUrl + "/generic/reTokenizeSavedPaymentMethod";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGenericReTokenizeSavedPaymentMethod(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGenericReTokenizeSavedPaymentMethod(<any>r));
                } catch (e) {
                    return <Observable<IFramePaymentPrepareResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IFramePaymentPrepareResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processGenericReTokenizeSavedPaymentMethod(response: HttpResponseBase): Observable<IFramePaymentPrepareResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IFramePaymentPrepareResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FisIntegrationApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return FisIntegrationApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(PAYMENT_INTEGRATIONS_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) FisIntegrationApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/payment-integrations";
    }

    static init(baseUrl: string){
        FisIntegrationApiClient._baseUrl = baseUrl;
    }

    /**
     * @param paymentMethodType The selected payment method type
     * @param forMultiPay Whether or not we need a jwt for multipay
     * @return OK
     */
    requestJwt(paymentMethodType: string, forMultiPay: boolean): Observable<SessionTokenResponseDto> {
        let url_ = this.baseUrl + "/fis/requestJwt/{PaymentMethodType}?";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (paymentMethodType === undefined || paymentMethodType === null)
            throw new Error("The parameter 'paymentMethodType' must be defined.");
        url_ = url_.replace("{PaymentMethodType}", encodeURIComponent("" + paymentMethodType));
        if (forMultiPay === undefined || forMultiPay === null)
            throw new Error("The parameter 'forMultiPay' must be defined and cannot be null.");
        else
            url_ += "ForMultiPay=" + encodeURIComponent("" + forMultiPay) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processRequestJwt(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processRequestJwt(<any>r));
                } catch (e) {
                    return <Observable<SessionTokenResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<SessionTokenResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processRequestJwt(response: HttpResponseBase): Observable<SessionTokenResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SessionTokenResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    preparePaymentAndAssessFees(body: IFramePaymentRequestDto): Observable<IFramePaymentPrepareResponseDto> {
        let url_ = this.baseUrl + "/fis/preparePaymentAndAssessFees";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processPreparePaymentAndAssessFees(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processPreparePaymentAndAssessFees(<any>r));
                } catch (e) {
                    return <Observable<IFramePaymentPrepareResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IFramePaymentPrepareResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processPreparePaymentAndAssessFees(response: HttpResponseBase): Observable<IFramePaymentPrepareResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IFramePaymentPrepareResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    fisGeneratePaymentDetails(body: FisPaymentDetailsRequestDto): Observable<FisPaymentDetailsResponseDto> {
        let url_ = this.baseUrl + "/fis/generatePaymentDetails";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processFisGeneratePaymentDetails(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processFisGeneratePaymentDetails(<any>r));
                } catch (e) {
                    return <Observable<FisPaymentDetailsResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<FisPaymentDetailsResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processFisGeneratePaymentDetails(response: HttpResponseBase): Observable<FisPaymentDetailsResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FisPaymentDetailsResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    fisVerifyPayment(body: FisVerifyPaymentRequestDto): Observable<IFramePaymentResponseDto> {
        let url_ = this.baseUrl + "/fis/verifyPayment";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processFisVerifyPayment(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processFisVerifyPayment(<any>r));
                } catch (e) {
                    return <Observable<IFramePaymentResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IFramePaymentResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processFisVerifyPayment(response: HttpResponseBase): Observable<IFramePaymentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IFramePaymentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WalletPaymentsIntegrationApiClient extends TellerOnlineApiClientBase {
    private http: HttpClient;
    private static _baseUrl: string;
    private get baseUrl() { return WalletPaymentsIntegrationApiClient._baseUrl }
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(TellerOnlineWindowService) configuration: TellerOnlineWindowService, @Inject(HttpClient) http: HttpClient, @Optional() @Inject(PAYMENT_INTEGRATIONS_API_BASE_URL) baseUrl?: string) {
        super(configuration);
        this.http = http;
        if(!this.baseUrl) WalletPaymentsIntegrationApiClient._baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "/api/payment-integrations";
    }

    static init(baseUrl: string){
        WalletPaymentsIntegrationApiClient._baseUrl = baseUrl;
    }

    /**
     * @return OK
     */
    makeWalletPayment(body: WalletPaymentRequestDto): Observable<IFramePaymentResponseDto> {
        let url_ = this.baseUrl + "/wallet-payments/make-payment";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processMakeWalletPayment(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processMakeWalletPayment(<any>r));
                } catch (e) {
                    return <Observable<IFramePaymentResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<IFramePaymentResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processMakeWalletPayment(response: HttpResponseBase): Observable<IFramePaymentResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IFramePaymentResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @return OK
     */
    validateApplePayMerchant(body: ApplePayMerchantValidationRequestDto): Observable<ApplePayMerchantValidationResponseDto> {
        let url_ = this.baseUrl + "/wallet-payments/apple-pay/validate-merchant";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("post", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processValidateApplePayMerchant(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processValidateApplePayMerchant(<any>r));
                } catch (e) {
                    return <Observable<ApplePayMerchantValidationResponseDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<ApplePayMerchantValidationResponseDto>><any>_observableThrow(response_);
        }));
    }

    protected processValidateApplePayMerchant(response: HttpResponseBase): Observable<ApplePayMerchantValidationResponseDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ApplePayMerchantValidationResponseDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * @param cartGuid Unique GUID of the cart
     * @return OK
     */
    getWalletPaymentAmount(cartGuid: string): Observable<WalletPaymentAmountDto> {
        let url_ = this.baseUrl + "/wallet-payments/{cartGuid}/amount";
        if (!navigator.onLine) {
            return _observableOf(null);
        }
        if (cartGuid === undefined || cartGuid === null)
            throw new Error("The parameter 'cartGuid' must be defined.");
        url_ = url_.replace("{cartGuid}", encodeURIComponent("" + cartGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return _observableFrom(this.transformOptions(options_)).pipe(_observableMergeMap(transformedOptions_ => {
            return this.http.request("get", url_, transformedOptions_);
        })).pipe(_observableMergeMap((response_: any) => {
            return this.transformResult(url_, response_, (r) => this.processGetWalletPaymentAmount(<any>r));
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.transformResult(url_, response_, (r) => this.processGetWalletPaymentAmount(<any>r));
                } catch (e) {
                    return <Observable<WalletPaymentAmountDto>><any>_observableThrow(e);
                }
            } else
                return <Observable<WalletPaymentAmountDto>><any>_observableThrow(response_);
        }));
    }

    protected processGetWalletPaymentAmount(response: HttpResponseBase): Observable<WalletPaymentAmountDto> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WalletPaymentAmountDto.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 500) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result500: any = null;
            let resultData500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result500 = ErrorDto.fromJS(resultData500);
            return throwException("Error", status, _responseText, _headers, result500);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class IFramePaymentRequestDto implements IIFramePaymentRequestDto {
    /** Unique ID of the cart being paid */
    cartId!: number;
    /** The cart's own guid, since cartId is a guessable
sequential int, the server requires this to also match the cart addressed
by cartId before charging or tokenizing against it. A missing or mismatched
value is rejected as UnauthorizedAccess.
 */
    cartGuid!: string;
    /** The token provided by the reCAPTCHA widget */
    captchaToken?: string | undefined;
    paymentMethodType!: PaymentMethodTypeEnumDto;
    /** Last 4 digits of card being used to pay */
    last4?: string;
    /** Visa, Mastercard, Discover, or Amex */
    cardType?: string;
    eCheckAccountType?: ECheckAccountTypeEnumDto;
    eCheckAccountOwnerType?: ECheckAccountOwnerTypeEnumDto;
    /** E-Check Account Number */
    eCheckAccountNumber?: string;
    /** E-Check Routing Number */
    eCheckRoutingNumber?: string;
    /** Month/Year of expiry */
    cardExpiry?: string;
    /** Full name */
    fullName?: string;
    /** Line 1 of the billing address fields */
    addressLine1?: string;
    /** Line 2 of the billing address fields */
    addressLine2?: string;
    /** Billing Address city */
    addressCity?: string;
    /** Billing Address state */
    addressState?: string;
    /** Billing address state code */
    addressStateCode?: string;
    /** Billing zip code */
    addressZip?: string;
    /** Billing address country */
    addressCountry?: string;
    /** Billing address ISO country code */
    addressCountryCode?: string;
    /** Address Phone number (e.g. (973) 552-2630) */
    phone?: string;
    /** CC Token */
    token?: string;
    /** If present this will trigger a test scenario with the payment processor if IsTestEnvironment = true */
    paymentProcessorTestTrigger?: string;
    /** The ID of the inbound redirect source where the request was initiated, if any. */
    inboundRedirectSourceId?: number;
    /** An additional processor-supplied token that must be included in order to successfully submit a payment. Used by FIS for the convenience-fee handle returned from a prior call. Not needed for most processors. */
    validationToken?: string;
    /** Per-request short-lived CVV token from VGS for credit-card payments. PCI-scope; never persisted server-side. */
    cvvToken?: string;
    /** The payment method type code returned to the processor. */
    processorPaymentMethodType?: string;
    /** User's affirmative consent to the AdHoc authorization text shown on
the checkout page (TOP-2935). The server — not the request shape —
decides whether consent is required: ECheck flows always require it
regardless of what the client sends; Credit flows require it only
when an active authorization text resolves (via the Credit→AdHoc
fallback chain), and omit it when none does.
 */
    authorizationConsent?: AuthorizationConsentDto;
    /** User's affirmative consent to the SavedPaymentMethod authorization
text shown in the in-checkout "Save Payment Method" modal when the
user opts to remember the method during ad-hoc checkout (TOP-2935
follow-up). Required only when the cart's rememberPaymentMethod is
true and the user is paying with a new (not already-saved) method;
null in every other request shape. The server validates the consent
against the SavedPaymentMethod authorization text version for the
cart's PaymentMethodType and rejects with AuthorizationConsentRequired
when rememberPaymentMethod is true and this field is null.
 */
    savedPaymentMethodAuthorizationConsent?: AuthorizationConsentDto;
    /** Per-partition session handles round-tripped from the prior prepare response so MakePayment can echo each partition's handle on its Authorize / Capture / CancelAuthorization wire call. Empty when no plugin initialized a session. */
    partitionSessionTokens?: CartPartitionSessionTokenDto[];
    /** The wallet type used for this payment. Null for non-wallet payments. */
    digitalWalletType?: DigitalWalletTypeEnumDto | undefined;

    [key: string]: any;

    constructor(data?: IIFramePaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cartId = _data["cartId"];
            this.cartGuid = _data["cartGuid"];
            this.captchaToken = _data["captchaToken"];
            this.paymentMethodType = _data["paymentMethodType"];
            this.last4 = _data["last4"];
            this.cardType = _data["cardType"];
            this.eCheckAccountType = _data["eCheckAccountType"];
            this.eCheckAccountOwnerType = _data["eCheckAccountOwnerType"];
            this.eCheckAccountNumber = _data["eCheckAccountNumber"];
            this.eCheckRoutingNumber = _data["eCheckRoutingNumber"];
            this.cardExpiry = _data["cardExpiry"];
            this.fullName = _data["fullName"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressCity = _data["addressCity"];
            this.addressState = _data["addressState"];
            this.addressStateCode = _data["addressStateCode"];
            this.addressZip = _data["addressZip"];
            this.addressCountry = _data["addressCountry"];
            this.addressCountryCode = _data["addressCountryCode"];
            this.phone = _data["phone"];
            this.token = _data["token"];
            this.paymentProcessorTestTrigger = _data["paymentProcessorTestTrigger"];
            this.inboundRedirectSourceId = _data["inboundRedirectSourceId"];
            this.validationToken = _data["validationToken"];
            this.cvvToken = _data["cvvToken"];
            this.processorPaymentMethodType = _data["processorPaymentMethodType"];
            this.authorizationConsent = _data["authorizationConsent"] ? AuthorizationConsentDto.fromJS(_data["authorizationConsent"]) : <any>undefined;
            this.savedPaymentMethodAuthorizationConsent = _data["savedPaymentMethodAuthorizationConsent"] ? AuthorizationConsentDto.fromJS(_data["savedPaymentMethodAuthorizationConsent"]) : <any>undefined;
            if (Array.isArray(_data["partitionSessionTokens"])) {
                this.partitionSessionTokens = [] as any;
                for (let item of _data["partitionSessionTokens"])
                    this.partitionSessionTokens!.push(CartPartitionSessionTokenDto.fromJS(item));
            }
            this.digitalWalletType = _data["digitalWalletType"];
        }
    }

    static fromJS(data: any): IFramePaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new IFramePaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cartId"] = this.cartId;
        data["cartGuid"] = this.cartGuid;
        data["captchaToken"] = this.captchaToken;
        data["paymentMethodType"] = this.paymentMethodType;
        data["last4"] = this.last4;
        data["cardType"] = this.cardType;
        data["eCheckAccountType"] = this.eCheckAccountType;
        data["eCheckAccountOwnerType"] = this.eCheckAccountOwnerType;
        data["eCheckAccountNumber"] = this.eCheckAccountNumber;
        data["eCheckRoutingNumber"] = this.eCheckRoutingNumber;
        data["cardExpiry"] = this.cardExpiry;
        data["fullName"] = this.fullName;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressCity"] = this.addressCity;
        data["addressState"] = this.addressState;
        data["addressStateCode"] = this.addressStateCode;
        data["addressZip"] = this.addressZip;
        data["addressCountry"] = this.addressCountry;
        data["addressCountryCode"] = this.addressCountryCode;
        data["phone"] = this.phone;
        data["token"] = this.token;
        data["paymentProcessorTestTrigger"] = this.paymentProcessorTestTrigger;
        data["inboundRedirectSourceId"] = this.inboundRedirectSourceId;
        data["validationToken"] = this.validationToken;
        data["cvvToken"] = this.cvvToken;
        data["processorPaymentMethodType"] = this.processorPaymentMethodType;
        data["authorizationConsent"] = this.authorizationConsent ? this.authorizationConsent.toJSON() : <any>undefined;
        data["savedPaymentMethodAuthorizationConsent"] = this.savedPaymentMethodAuthorizationConsent ? this.savedPaymentMethodAuthorizationConsent.toJSON() : <any>undefined;
        if (Array.isArray(this.partitionSessionTokens)) {
            data["partitionSessionTokens"] = [];
            for (let item of this.partitionSessionTokens)
                data["partitionSessionTokens"].push(item.toJSON());
        }
        data["digitalWalletType"] = this.digitalWalletType;
        return data;
    }
}

export interface IIFramePaymentRequestDto {
    /** Unique ID of the cart being paid */
    cartId: number;
    /** The cart's own guid, since cartId is a guessable
sequential int, the server requires this to also match the cart addressed
by cartId before charging or tokenizing against it. A missing or mismatched
value is rejected as UnauthorizedAccess.
 */
    cartGuid: string;
    /** The token provided by the reCAPTCHA widget */
    captchaToken?: string | undefined;
    paymentMethodType: PaymentMethodTypeEnumDto;
    /** Last 4 digits of card being used to pay */
    last4?: string;
    /** Visa, Mastercard, Discover, or Amex */
    cardType?: string;
    eCheckAccountType?: ECheckAccountTypeEnumDto;
    eCheckAccountOwnerType?: ECheckAccountOwnerTypeEnumDto;
    /** E-Check Account Number */
    eCheckAccountNumber?: string;
    /** E-Check Routing Number */
    eCheckRoutingNumber?: string;
    /** Month/Year of expiry */
    cardExpiry?: string;
    /** Full name */
    fullName?: string;
    /** Line 1 of the billing address fields */
    addressLine1?: string;
    /** Line 2 of the billing address fields */
    addressLine2?: string;
    /** Billing Address city */
    addressCity?: string;
    /** Billing Address state */
    addressState?: string;
    /** Billing address state code */
    addressStateCode?: string;
    /** Billing zip code */
    addressZip?: string;
    /** Billing address country */
    addressCountry?: string;
    /** Billing address ISO country code */
    addressCountryCode?: string;
    /** Address Phone number (e.g. (973) 552-2630) */
    phone?: string;
    /** CC Token */
    token?: string;
    /** If present this will trigger a test scenario with the payment processor if IsTestEnvironment = true */
    paymentProcessorTestTrigger?: string;
    /** The ID of the inbound redirect source where the request was initiated, if any. */
    inboundRedirectSourceId?: number;
    /** An additional processor-supplied token that must be included in order to successfully submit a payment. Used by FIS for the convenience-fee handle returned from a prior call. Not needed for most processors. */
    validationToken?: string;
    /** Per-request short-lived CVV token from VGS for credit-card payments. PCI-scope; never persisted server-side. */
    cvvToken?: string;
    /** The payment method type code returned to the processor. */
    processorPaymentMethodType?: string;
    /** User's affirmative consent to the AdHoc authorization text shown on
the checkout page (TOP-2935). The server — not the request shape —
decides whether consent is required: ECheck flows always require it
regardless of what the client sends; Credit flows require it only
when an active authorization text resolves (via the Credit→AdHoc
fallback chain), and omit it when none does.
 */
    authorizationConsent?: AuthorizationConsentDto;
    /** User's affirmative consent to the SavedPaymentMethod authorization
text shown in the in-checkout "Save Payment Method" modal when the
user opts to remember the method during ad-hoc checkout (TOP-2935
follow-up). Required only when the cart's rememberPaymentMethod is
true and the user is paying with a new (not already-saved) method;
null in every other request shape. The server validates the consent
against the SavedPaymentMethod authorization text version for the
cart's PaymentMethodType and rejects with AuthorizationConsentRequired
when rememberPaymentMethod is true and this field is null.
 */
    savedPaymentMethodAuthorizationConsent?: AuthorizationConsentDto;
    /** Per-partition session handles round-tripped from the prior prepare response so MakePayment can echo each partition's handle on its Authorize / Capture / CancelAuthorization wire call. Empty when no plugin initialized a session. */
    partitionSessionTokens?: CartPartitionSessionTokenDto[];
    /** The wallet type used for this payment. Null for non-wallet payments. */
    digitalWalletType?: DigitalWalletTypeEnumDto | undefined;

    [key: string]: any;
}

/** Response to posting a payment */
export class IFramePaymentResponseDto implements IIFramePaymentResponseDto {
    /** Email address where the receipt is mailed. */
    emailAddress?: string;
    /** True if the payment succeeded, false otherwise */
    responseSuccess?: any;
    /** The error message corresponding to a failed payment */
    responseMessage?: string;
    /** Tracking number provided by payment processor upon completion of successful payment. */
    processorTrackingId?: string;

    [key: string]: any;

    constructor(data?: IIFramePaymentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.emailAddress = _data["emailAddress"];
            this.responseSuccess = _data["responseSuccess"];
            this.responseMessage = _data["responseMessage"];
            this.processorTrackingId = _data["processorTrackingId"];
        }
    }

    static fromJS(data: any): IFramePaymentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new IFramePaymentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["emailAddress"] = this.emailAddress;
        data["responseSuccess"] = this.responseSuccess;
        data["responseMessage"] = this.responseMessage;
        data["processorTrackingId"] = this.processorTrackingId;
        return data;
    }
}

/** Response to posting a payment */
export interface IIFramePaymentResponseDto {
    /** Email address where the receipt is mailed. */
    emailAddress?: string;
    /** True if the payment succeeded, false otherwise */
    responseSuccess?: any;
    /** The error message corresponding to a failed payment */
    responseMessage?: string;
    /** Tracking number provided by payment processor upon completion of successful payment. */
    processorTrackingId?: string;

    [key: string]: any;
}

export class IFrameSavePaymentMethodRequestDto implements IIFrameSavePaymentMethodRequestDto {
    /** The token provided by the recaptcha widget */
    captchaToken?: string | undefined;
    /** Last 4 digits of card being used to pay */
    last4?: string;
    /** Visa, Mastercard, Discover, or Amex */
    cardType?: string;
    /** When the card expires (MMYY) */
    cardExpiry?: string;
    eCheckAccountType?: ECheckAccountTypeEnumDto;
    eCheckAccountOwnerType?: ECheckAccountOwnerTypeEnumDto;
    /** E-Check Account Number */
    eCheckAccountNumber?: string;
    /** E-Check Routing Number */
    eCheckRoutingNumber?: string;
    /** Full name */
    fullName?: string;
    /** Line 1 of the billing address fields */
    addressLine1?: string;
    /** Line 2 of the billing address fields */
    addressLine2?: string;
    /** Billing Address city */
    addressCity?: string;
    /** Billing Address state */
    addressState?: string;
    /** Billing address state code */
    addressStateCode?: string;
    /** Billing zip code */
    addressZip?: string;
    /** Billing address country */
    addressCountry?: string;
    /** Billing address ISO country code */
    addressCountryCode?: string;
    /** Address Phone number (e.g. (973) 552-2630) */
    phone?: string;
    /** VGS card-number alias (or eCheck account number when applicable). For credit-card saves this is the durable VGS token; the per-request CVV travels separately on cvvToken. */
    token?: string;
    /** Per-request short-lived CVV token from VGS for credit-card saves. PCI-scope; never persisted server-side. */
    cvvToken?: string;
    paymentMethodType!: PaymentMethodTypeEnumDto;
    /** User's affirmative consent to the SavedPaymentMethod authorization
text shown on the save/update payment-method form (TOP-2935).
Required for ECheck and for Credit when the tenant has configured
an active text (or it cascades via AdHoc fallback). The server, not
the request shape, decides whether consent is required.
 */
    authorizationConsent?: AuthorizationConsentDto;

    [key: string]: any;

    constructor(data?: IIFrameSavePaymentMethodRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.captchaToken = _data["captchaToken"];
            this.last4 = _data["last4"];
            this.cardType = _data["cardType"];
            this.cardExpiry = _data["cardExpiry"];
            this.eCheckAccountType = _data["eCheckAccountType"];
            this.eCheckAccountOwnerType = _data["eCheckAccountOwnerType"];
            this.eCheckAccountNumber = _data["eCheckAccountNumber"];
            this.eCheckRoutingNumber = _data["eCheckRoutingNumber"];
            this.fullName = _data["fullName"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressCity = _data["addressCity"];
            this.addressState = _data["addressState"];
            this.addressStateCode = _data["addressStateCode"];
            this.addressZip = _data["addressZip"];
            this.addressCountry = _data["addressCountry"];
            this.addressCountryCode = _data["addressCountryCode"];
            this.phone = _data["phone"];
            this.token = _data["token"];
            this.cvvToken = _data["cvvToken"];
            this.paymentMethodType = _data["PaymentMethodType"];
            this.authorizationConsent = _data["authorizationConsent"] ? AuthorizationConsentDto.fromJS(_data["authorizationConsent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IFrameSavePaymentMethodRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new IFrameSavePaymentMethodRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["captchaToken"] = this.captchaToken;
        data["last4"] = this.last4;
        data["cardType"] = this.cardType;
        data["cardExpiry"] = this.cardExpiry;
        data["eCheckAccountType"] = this.eCheckAccountType;
        data["eCheckAccountOwnerType"] = this.eCheckAccountOwnerType;
        data["eCheckAccountNumber"] = this.eCheckAccountNumber;
        data["eCheckRoutingNumber"] = this.eCheckRoutingNumber;
        data["fullName"] = this.fullName;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressCity"] = this.addressCity;
        data["addressState"] = this.addressState;
        data["addressStateCode"] = this.addressStateCode;
        data["addressZip"] = this.addressZip;
        data["addressCountry"] = this.addressCountry;
        data["addressCountryCode"] = this.addressCountryCode;
        data["phone"] = this.phone;
        data["token"] = this.token;
        data["cvvToken"] = this.cvvToken;
        data["PaymentMethodType"] = this.paymentMethodType;
        data["authorizationConsent"] = this.authorizationConsent ? this.authorizationConsent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIFrameSavePaymentMethodRequestDto {
    /** The token provided by the recaptcha widget */
    captchaToken?: string | undefined;
    /** Last 4 digits of card being used to pay */
    last4?: string;
    /** Visa, Mastercard, Discover, or Amex */
    cardType?: string;
    /** When the card expires (MMYY) */
    cardExpiry?: string;
    eCheckAccountType?: ECheckAccountTypeEnumDto;
    eCheckAccountOwnerType?: ECheckAccountOwnerTypeEnumDto;
    /** E-Check Account Number */
    eCheckAccountNumber?: string;
    /** E-Check Routing Number */
    eCheckRoutingNumber?: string;
    /** Full name */
    fullName?: string;
    /** Line 1 of the billing address fields */
    addressLine1?: string;
    /** Line 2 of the billing address fields */
    addressLine2?: string;
    /** Billing Address city */
    addressCity?: string;
    /** Billing Address state */
    addressState?: string;
    /** Billing address state code */
    addressStateCode?: string;
    /** Billing zip code */
    addressZip?: string;
    /** Billing address country */
    addressCountry?: string;
    /** Billing address ISO country code */
    addressCountryCode?: string;
    /** Address Phone number (e.g. (973) 552-2630) */
    phone?: string;
    /** VGS card-number alias (or eCheck account number when applicable). For credit-card saves this is the durable VGS token; the per-request CVV travels separately on cvvToken. */
    token?: string;
    /** Per-request short-lived CVV token from VGS for credit-card saves. PCI-scope; never persisted server-side. */
    cvvToken?: string;
    paymentMethodType: PaymentMethodTypeEnumDto;
    /** User's affirmative consent to the SavedPaymentMethod authorization
text shown on the save/update payment-method form (TOP-2935).
Required for ECheck and for Credit when the tenant has configured
an active text (or it cascades via AdHoc fallback). The server, not
the request shape, decides whether consent is required.
 */
    authorizationConsent?: AuthorizationConsentDto;

    [key: string]: any;
}

/** Response to updating a payment method */
export class IFrameSavePaymentMethodResponseDto implements IIFrameSavePaymentMethodResponseDto {
    /** The id of the new payment method */
    paymentMethodId?: number;
    /** Last 4 digits of the payment method */
    last4?: string;

    [key: string]: any;

    constructor(data?: IIFrameSavePaymentMethodResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentMethodId = _data["paymentMethodId"];
            this.last4 = _data["last4"];
        }
    }

    static fromJS(data: any): IFrameSavePaymentMethodResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new IFrameSavePaymentMethodResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentMethodId"] = this.paymentMethodId;
        data["last4"] = this.last4;
        return data;
    }
}

/** Response to updating a payment method */
export interface IIFrameSavePaymentMethodResponseDto {
    /** The id of the new payment method */
    paymentMethodId?: number;
    /** Last 4 digits of the payment method */
    last4?: string;

    [key: string]: any;
}

/** Permitted payment methods for a cart, with exclusion reasons */
export class AvailablePaymentMethodsResponseDto implements IAvailablePaymentMethodsResponseDto {
    paymentMethods?: AvailablePaymentMethodDto[];

    [key: string]: any;

    constructor(data?: IAvailablePaymentMethodsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["paymentMethods"])) {
                this.paymentMethods = [] as any;
                for (let item of _data["paymentMethods"])
                    this.paymentMethods!.push(AvailablePaymentMethodDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AvailablePaymentMethodsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailablePaymentMethodsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.paymentMethods)) {
            data["paymentMethods"] = [];
            for (let item of this.paymentMethods)
                data["paymentMethods"].push(item.toJSON());
        }
        return data;
    }
}

/** Permitted payment methods for a cart, with exclusion reasons */
export interface IAvailablePaymentMethodsResponseDto {
    paymentMethods?: AvailablePaymentMethodDto[];

    [key: string]: any;
}

export class AvailablePaymentMethodDto implements IAvailablePaymentMethodDto {
    paymentMethodType?: PaymentMethodTypeEnumDto;
    available?: boolean;
    /** Why the method was excluded, so the payer can be told rather than
watching an option vanish. One of ProcessorDisabled, PolicyDisabled,
ExceedsMaxAmount or BelowMinAmount. Null when the method is available.
 */
    reason?: string | undefined;
    /** The page whose configuration excluded this method. Null when available,
or when the exclusion is tenant-wide rather than attributable to a page.

Also identifies WHICH payment of a multi-payment cart a bound belongs to:
the checkout page finds the cart group holding this page and names it in
the words its own cart slider uses. The connection's name is deliberately
not sent for that - a payer has never seen a connection.
 */
    blockingPageId?: number | undefined;
    /** The configured bound the payment breached: MaxAmount when reason is
ExceedsMaxAmount, MinAmount when it is BelowMinAmount. Set for those two
reasons only, so the payer can be told the bound rather than just
"not available".

Deliberately the bound and not the gap to it. A shortfall has to be
quoted including the convenience fee, which is a proportion of a total
the payer cannot reach yet - so every gap we quoted was understated, and
more so the smaller the cart. The bound is a fact about the
configuration and needs no such arithmetic.
 */
    limitAmount?: number | undefined;

    [key: string]: any;

    constructor(data?: IAvailablePaymentMethodDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentMethodType = _data["paymentMethodType"];
            this.available = _data["available"];
            this.reason = _data["reason"];
            this.blockingPageId = _data["blockingPageId"];
            this.limitAmount = _data["limitAmount"];
        }
    }

    static fromJS(data: any): AvailablePaymentMethodDto {
        data = typeof data === 'object' ? data : {};
        let result = new AvailablePaymentMethodDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentMethodType"] = this.paymentMethodType;
        data["available"] = this.available;
        data["reason"] = this.reason;
        data["blockingPageId"] = this.blockingPageId;
        data["limitAmount"] = this.limitAmount;
        return data;
    }
}

export interface IAvailablePaymentMethodDto {
    paymentMethodType?: PaymentMethodTypeEnumDto;
    available?: boolean;
    /** Why the method was excluded, so the payer can be told rather than
watching an option vanish. One of ProcessorDisabled, PolicyDisabled,
ExceedsMaxAmount or BelowMinAmount. Null when the method is available.
 */
    reason?: string | undefined;
    /** The page whose configuration excluded this method. Null when available,
or when the exclusion is tenant-wide rather than attributable to a page.

Also identifies WHICH payment of a multi-payment cart a bound belongs to:
the checkout page finds the cart group holding this page and names it in
the words its own cart slider uses. The connection's name is deliberately
not sent for that - a payer has never seen a connection.
 */
    blockingPageId?: number | undefined;
    /** The configured bound the payment breached: MaxAmount when reason is
ExceedsMaxAmount, MinAmount when it is BelowMinAmount. Set for those two
reasons only, so the payer can be told the bound rather than just
"not available".

Deliberately the bound and not the gap to it. A shortfall has to be
quoted including the convenience fee, which is a proportion of a total
the payer cannot reach yet - so every gap we quoted was understated, and
more so the smaller the cart. The bound is a fact about the
configuration and needs no such arithmetic.
 */
    limitAmount?: number | undefined;

    [key: string]: any;
}

export class PaymentConfigResponseDto implements IPaymentConfigResponseDto {
    defaultConfig?: PaymentConfigDto;
    /** Union across every page on the site - any method permitted somewhere.
For surfaces with no cart context, such as saved payment methods:
restricting which methods a user may SAVE would be wrong when some page
accepts them. Deliberately a union, not an intersection.
 */
    siteAvailablePaymentMethods?: PaymentMethodTypeEnumDto[];
    configOverrides?: PaymentConfigDto[];
    /** Aggregated plugin configuration. Populated when the tenant uses the
Generic payment integration for at least one payment method. Null for
tenants whose Credit and ECheck integrations are both non-Generic.
 */
    pluginConfig?: AggregatedPluginConfigDto | undefined;
    /** Flat list of wallet SDK configs for all (tellerSystemCode, configKey)
combinations active on this site. Frontend matches the current
partition's keys to find its entry. Empty list means no wallet
capabilities are configured.
 */
    walletCapabilities?: WalletCapabilityEntryDto[];

    [key: string]: any;

    constructor(data?: IPaymentConfigResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.defaultConfig = _data["defaultConfig"] ? PaymentConfigDto.fromJS(_data["defaultConfig"]) : <any>undefined;
            if (Array.isArray(_data["siteAvailablePaymentMethods"])) {
                this.siteAvailablePaymentMethods = [] as any;
                for (let item of _data["siteAvailablePaymentMethods"])
                    this.siteAvailablePaymentMethods!.push(item);
            }
            if (Array.isArray(_data["configOverrides"])) {
                this.configOverrides = [] as any;
                for (let item of _data["configOverrides"])
                    this.configOverrides!.push(PaymentConfigDto.fromJS(item));
            }
            this.pluginConfig = _data["pluginConfig"] ? AggregatedPluginConfigDto.fromJS(_data["pluginConfig"]) : <any>undefined;
            if (Array.isArray(_data["walletCapabilities"])) {
                this.walletCapabilities = [] as any;
                for (let item of _data["walletCapabilities"])
                    this.walletCapabilities!.push(WalletCapabilityEntryDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PaymentConfigResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentConfigResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["defaultConfig"] = this.defaultConfig ? this.defaultConfig.toJSON() : <any>undefined;
        if (Array.isArray(this.siteAvailablePaymentMethods)) {
            data["siteAvailablePaymentMethods"] = [];
            for (let item of this.siteAvailablePaymentMethods)
                data["siteAvailablePaymentMethods"].push(item);
        }
        if (Array.isArray(this.configOverrides)) {
            data["configOverrides"] = [];
            for (let item of this.configOverrides)
                data["configOverrides"].push(item.toJSON());
        }
        data["pluginConfig"] = this.pluginConfig ? this.pluginConfig.toJSON() : <any>undefined;
        if (Array.isArray(this.walletCapabilities)) {
            data["walletCapabilities"] = [];
            for (let item of this.walletCapabilities)
                data["walletCapabilities"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPaymentConfigResponseDto {
    defaultConfig?: PaymentConfigDto;
    /** Union across every page on the site - any method permitted somewhere.
For surfaces with no cart context, such as saved payment methods:
restricting which methods a user may SAVE would be wrong when some page
accepts them. Deliberately a union, not an intersection.
 */
    siteAvailablePaymentMethods?: PaymentMethodTypeEnumDto[];
    configOverrides?: PaymentConfigDto[];
    /** Aggregated plugin configuration. Populated when the tenant uses the
Generic payment integration for at least one payment method. Null for
tenants whose Credit and ECheck integrations are both non-Generic.
 */
    pluginConfig?: AggregatedPluginConfigDto | undefined;
    /** Flat list of wallet SDK configs for all (tellerSystemCode, configKey)
combinations active on this site. Frontend matches the current
partition's keys to find its entry. Empty list means no wallet
capabilities are configured.
 */
    walletCapabilities?: WalletCapabilityEntryDto[];

    [key: string]: any;
}

export class PaymentConfigDto implements IPaymentConfigDto {
    /** Whether or not this processor is enabled
True: The payment method(s) this processor supports will be usable
False: The payment method(s) this processor supports will not be displayed or usable
 */
    enabled!: boolean;
    /** The number of minutes the processor will allow the user to complete the payment */
    processorExpiryTime?: number;
    /** The number of seconds to wait when polling for changes to the cart hash */
    cartHashRefreshTime?: number;
    /** Unique identifier for this configuration to be used when attempting
to override the payment config for a subset of items in the cart.
 */
    configKey?: string;
    /** Convenience fee information that will override default convenience fee config */
    creditConfig?: PaymentConfigMethodOverrideDto;
    /** Convenience fee information that will override default convenience fee config */
    eCheckConfig?: PaymentConfigMethodOverrideDto;
    /** Whether or not we will calculate the convenience fee on our side
True: we will calculate (approximate) it ahead of time to display
False: the fee will only be calculated in the payment portal
 */
    convenienceFeeEnabled!: boolean;
    /** An alternate label to use in place of the default "Convenience Fee" */
    convenienceFeeLabel?: string;
    /** The message to display next to the convenience fee item (via the "i" icon) */
    convenienceFeeNote?: string;
    /** What format the rate is stored as (percent, flat, other) */
    convenienceFeeFormat?: string;
    /** The rate the convenience fee is charged at
Stored as a represetation matching the format
e.g. 3% would be 0.03, $50 would be 50
If the rate is more complex, use format "other" and do not fill this out
 */
    convenienceFeeRate?: number;
    /** Any additional data that is needed to be sent from the backend to frontend */
    additionalData?: { [key: string]: string; };

    [key: string]: any;

    constructor(data?: IPaymentConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.enabled = _data["enabled"];
            this.processorExpiryTime = _data["processorExpiryTime"];
            this.cartHashRefreshTime = _data["cartHashRefreshTime"];
            this.configKey = _data["configKey"];
            this.creditConfig = _data["creditConfig"] ? PaymentConfigMethodOverrideDto.fromJS(_data["creditConfig"]) : <any>undefined;
            this.eCheckConfig = _data["eCheckConfig"] ? PaymentConfigMethodOverrideDto.fromJS(_data["eCheckConfig"]) : <any>undefined;
            this.convenienceFeeEnabled = _data["convenienceFeeEnabled"];
            this.convenienceFeeLabel = _data["convenienceFeeLabel"];
            this.convenienceFeeNote = _data["convenienceFeeNote"];
            this.convenienceFeeFormat = _data["convenienceFeeFormat"];
            this.convenienceFeeRate = _data["convenienceFeeRate"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (<any>this.additionalData)![key] = _data["additionalData"][key];
                }
            }
        }
    }

    static fromJS(data: any): PaymentConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["enabled"] = this.enabled;
        data["processorExpiryTime"] = this.processorExpiryTime;
        data["cartHashRefreshTime"] = this.cartHashRefreshTime;
        data["configKey"] = this.configKey;
        data["creditConfig"] = this.creditConfig ? this.creditConfig.toJSON() : <any>undefined;
        data["eCheckConfig"] = this.eCheckConfig ? this.eCheckConfig.toJSON() : <any>undefined;
        data["convenienceFeeEnabled"] = this.convenienceFeeEnabled;
        data["convenienceFeeLabel"] = this.convenienceFeeLabel;
        data["convenienceFeeNote"] = this.convenienceFeeNote;
        data["convenienceFeeFormat"] = this.convenienceFeeFormat;
        data["convenienceFeeRate"] = this.convenienceFeeRate;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (<any>data["additionalData"])[key] = (<any>this.additionalData)[key];
            }
        }
        return data;
    }
}

export interface IPaymentConfigDto {
    /** Whether or not this processor is enabled
True: The payment method(s) this processor supports will be usable
False: The payment method(s) this processor supports will not be displayed or usable
 */
    enabled: boolean;
    /** The number of minutes the processor will allow the user to complete the payment */
    processorExpiryTime?: number;
    /** The number of seconds to wait when polling for changes to the cart hash */
    cartHashRefreshTime?: number;
    /** Unique identifier for this configuration to be used when attempting
to override the payment config for a subset of items in the cart.
 */
    configKey?: string;
    /** Convenience fee information that will override default convenience fee config */
    creditConfig?: PaymentConfigMethodOverrideDto;
    /** Convenience fee information that will override default convenience fee config */
    eCheckConfig?: PaymentConfigMethodOverrideDto;
    /** Whether or not we will calculate the convenience fee on our side
True: we will calculate (approximate) it ahead of time to display
False: the fee will only be calculated in the payment portal
 */
    convenienceFeeEnabled: boolean;
    /** An alternate label to use in place of the default "Convenience Fee" */
    convenienceFeeLabel?: string;
    /** The message to display next to the convenience fee item (via the "i" icon) */
    convenienceFeeNote?: string;
    /** What format the rate is stored as (percent, flat, other) */
    convenienceFeeFormat?: string;
    /** The rate the convenience fee is charged at
Stored as a represetation matching the format
e.g. 3% would be 0.03, $50 would be 50
If the rate is more complex, use format "other" and do not fill this out
 */
    convenienceFeeRate?: number;
    /** Any additional data that is needed to be sent from the backend to frontend */
    additionalData?: { [key: string]: string; };

    [key: string]: any;
}

/** Payment identifier for the newly created payment */
export class StartPaymentResponseDto implements IStartPaymentResponseDto {
    /** Unique identifier for the payment */
    paymentIdentifier?: string;
    /** Redirect url for the payment */
    redirectUrl?: string | undefined;
    /** HTTP method used to redirect (GET or POST). Null falls back to GET. */
    redirectMethod?: string | undefined;
    /** Hidden form inputs to include when redirecting via POST. */
    redirectFormInputs?: RedirectFormInputDto[] | undefined;

    [key: string]: any;

    constructor(data?: IStartPaymentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentIdentifier = _data["paymentIdentifier"];
            this.redirectUrl = _data["redirectUrl"];
            this.redirectMethod = _data["redirectMethod"];
            if (Array.isArray(_data["redirectFormInputs"])) {
                this.redirectFormInputs = [] as any;
                for (let item of _data["redirectFormInputs"])
                    this.redirectFormInputs!.push(RedirectFormInputDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StartPaymentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new StartPaymentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentIdentifier"] = this.paymentIdentifier;
        data["redirectUrl"] = this.redirectUrl;
        data["redirectMethod"] = this.redirectMethod;
        if (Array.isArray(this.redirectFormInputs)) {
            data["redirectFormInputs"] = [];
            for (let item of this.redirectFormInputs)
                data["redirectFormInputs"].push(item.toJSON());
        }
        return data;
    }
}

/** Payment identifier for the newly created payment */
export interface IStartPaymentResponseDto {
    /** Unique identifier for the payment */
    paymentIdentifier?: string;
    /** Redirect url for the payment */
    redirectUrl?: string | undefined;
    /** HTTP method used to redirect (GET or POST). Null falls back to GET. */
    redirectMethod?: string | undefined;
    /** Hidden form inputs to include when redirecting via POST. */
    redirectFormInputs?: RedirectFormInputDto[] | undefined;

    [key: string]: any;
}

/** Convenience fee amounts for each partition of the cart. */
export class ConvenienceFeeResponseDto implements IConvenienceFeeResponseDto {
    /** The convenience fee amounts for the groupings in the cart. */
    fees?: ConvenienceFeeDto[];

    [key: string]: any;

    constructor(data?: IConvenienceFeeResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["fees"])) {
                this.fees = [] as any;
                for (let item of _data["fees"])
                    this.fees!.push(ConvenienceFeeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ConvenienceFeeResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConvenienceFeeResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.fees)) {
            data["fees"] = [];
            for (let item of this.fees)
                data["fees"].push(item.toJSON());
        }
        return data;
    }
}

/** Convenience fee amounts for each partition of the cart. */
export interface IConvenienceFeeResponseDto {
    /** The convenience fee amounts for the groupings in the cart. */
    fees?: ConvenienceFeeDto[];

    [key: string]: any;
}

export class ConvenienceFeeDto implements IConvenienceFeeDto {
    /** The convenience fee amount */
    amount?: number;
    /** Key used for config overrides */
    configKey?: string;
    /** The teller system code for the partition this fee belongs to */
    tellerSystemCode?: string;

    [key: string]: any;

    constructor(data?: IConvenienceFeeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.amount = _data["amount"];
            this.configKey = _data["configKey"];
            this.tellerSystemCode = _data["tellerSystemCode"];
        }
    }

    static fromJS(data: any): ConvenienceFeeDto {
        data = typeof data === 'object' ? data : {};
        let result = new ConvenienceFeeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["amount"] = this.amount;
        data["configKey"] = this.configKey;
        data["tellerSystemCode"] = this.tellerSystemCode;
        return data;
    }
}

export interface IConvenienceFeeDto {
    /** The convenience fee amount */
    amount?: number;
    /** Key used for config overrides */
    configKey?: string;
    /** The teller system code for the partition this fee belongs to */
    tellerSystemCode?: string;

    [key: string]: any;
}

export class PaymentConfigMethodOverrideDto implements IPaymentConfigMethodOverrideDto {
    /** Whether or not this processor is enabled
True: The payment method(s) this processor supports will be usable
False: The payment method(s) this processor supports will not be displayed or usable
 */
    enabled!: boolean;
    /** The number of minutes the processor will allow the user to complete the payment */
    processorExpiryTime?: number;
    /** The number of seconds to wait when polling for changes to the cart hash */
    cartHashRefreshTime?: number;
    /** Whether or not we will calculate the convenience fee on our side
True: we will calculate (approximate) it ahead of time to display
False: the fee will only be calculated in the payment portal
 */
    convenienceFeeEnabled!: boolean;
    /** An alternate label to use in place of the default "Convenience Fee" */
    convenienceFeeLabel?: string;
    /** The message to display next to the convenience fee item (via the "i" icon) */
    convenienceFeeNote?: string;
    /** What format the rate is stored as (percent, flat, other) */
    convenienceFeeFormat?: string;
    /** The rate the convenience fee is charged at
Stored as a represetation matching the format
e.g. 3% would be 0.03, $50 would be 50
If the rate is more complex, use format "other" and do not fill this out
 */
    convenienceFeeRate?: number;
    /** Determines whether or not dual entry of account and routing numbers are required when paying by E-Check. */
    requireDualEntryForECheck?: any;
    /** Whether to use VGS Collect iframe for echeck fields instead of the hardcoded echeck form. */
    useVgsForECheck?: boolean;
    /** Any additional data that is needed to be sent from the backend to frontend */
    additionalData?: { [key: string]: string; };
    /** Whether or not credit cards can be saved to pay with later via tokenization
  True: we will allow the user to select to store the CC for later use in which case
      we will store a token for later use
  False: the user will not get the option to store their CC payment method
 */
    supportsTokenization?: boolean;
    /** If this is a test environment, this may be populated with a test trigger which will appear
on the UI to allow a tester to trigger certain scenarios with the payment processor.
 */
    testTriggers?: { [key: string]: string; };
    /** List of accepted card brands for display in the UI (e.g., ["visa", "mastercard", "amex", "discover"]).
If not specified or empty, no card brand logos will be displayed.
 */
    acceptedCardBrands?: string[];
    /** Regular expression matching a SINGLE character the payment processor permits
in a billing name (e.g., "[A-Za-z0-9 ',.\-]"). Anything the pattern does not
match is rejected before submission. Null when the processor imposes no
restriction.
 */
    allowedBillingNameCharacterPattern?: string | undefined;
    /** Longest billing name the payment processor accepts (e.g., 100). Null when the
processor imposes no limit.
 */
    maxBillingNameLength?: number | undefined;

    [key: string]: any;

    constructor(data?: IPaymentConfigMethodOverrideDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.enabled = _data["enabled"];
            this.processorExpiryTime = _data["processorExpiryTime"];
            this.cartHashRefreshTime = _data["cartHashRefreshTime"];
            this.convenienceFeeEnabled = _data["convenienceFeeEnabled"];
            this.convenienceFeeLabel = _data["convenienceFeeLabel"];
            this.convenienceFeeNote = _data["convenienceFeeNote"];
            this.convenienceFeeFormat = _data["convenienceFeeFormat"];
            this.convenienceFeeRate = _data["convenienceFeeRate"];
            this.requireDualEntryForECheck = _data["requireDualEntryForECheck"];
            this.useVgsForECheck = _data["useVgsForECheck"];
            if (_data["additionalData"]) {
                this.additionalData = {} as any;
                for (let key in _data["additionalData"]) {
                    if (_data["additionalData"].hasOwnProperty(key))
                        (<any>this.additionalData)![key] = _data["additionalData"][key];
                }
            }
            this.supportsTokenization = _data["supportsTokenization"];
            if (_data["testTriggers"]) {
                this.testTriggers = {} as any;
                for (let key in _data["testTriggers"]) {
                    if (_data["testTriggers"].hasOwnProperty(key))
                        (<any>this.testTriggers)![key] = _data["testTriggers"][key];
                }
            }
            if (Array.isArray(_data["acceptedCardBrands"])) {
                this.acceptedCardBrands = [] as any;
                for (let item of _data["acceptedCardBrands"])
                    this.acceptedCardBrands!.push(item);
            }
            this.allowedBillingNameCharacterPattern = _data["allowedBillingNameCharacterPattern"];
            this.maxBillingNameLength = _data["maxBillingNameLength"];
        }
    }

    static fromJS(data: any): PaymentConfigMethodOverrideDto {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentConfigMethodOverrideDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["enabled"] = this.enabled;
        data["processorExpiryTime"] = this.processorExpiryTime;
        data["cartHashRefreshTime"] = this.cartHashRefreshTime;
        data["convenienceFeeEnabled"] = this.convenienceFeeEnabled;
        data["convenienceFeeLabel"] = this.convenienceFeeLabel;
        data["convenienceFeeNote"] = this.convenienceFeeNote;
        data["convenienceFeeFormat"] = this.convenienceFeeFormat;
        data["convenienceFeeRate"] = this.convenienceFeeRate;
        data["requireDualEntryForECheck"] = this.requireDualEntryForECheck;
        data["useVgsForECheck"] = this.useVgsForECheck;
        if (this.additionalData) {
            data["additionalData"] = {};
            for (let key in this.additionalData) {
                if (this.additionalData.hasOwnProperty(key))
                    (<any>data["additionalData"])[key] = (<any>this.additionalData)[key];
            }
        }
        data["supportsTokenization"] = this.supportsTokenization;
        if (this.testTriggers) {
            data["testTriggers"] = {};
            for (let key in this.testTriggers) {
                if (this.testTriggers.hasOwnProperty(key))
                    (<any>data["testTriggers"])[key] = (<any>this.testTriggers)[key];
            }
        }
        if (Array.isArray(this.acceptedCardBrands)) {
            data["acceptedCardBrands"] = [];
            for (let item of this.acceptedCardBrands)
                data["acceptedCardBrands"].push(item);
        }
        data["allowedBillingNameCharacterPattern"] = this.allowedBillingNameCharacterPattern;
        data["maxBillingNameLength"] = this.maxBillingNameLength;
        return data;
    }
}

export interface IPaymentConfigMethodOverrideDto {
    /** Whether or not this processor is enabled
True: The payment method(s) this processor supports will be usable
False: The payment method(s) this processor supports will not be displayed or usable
 */
    enabled: boolean;
    /** The number of minutes the processor will allow the user to complete the payment */
    processorExpiryTime?: number;
    /** The number of seconds to wait when polling for changes to the cart hash */
    cartHashRefreshTime?: number;
    /** Whether or not we will calculate the convenience fee on our side
True: we will calculate (approximate) it ahead of time to display
False: the fee will only be calculated in the payment portal
 */
    convenienceFeeEnabled: boolean;
    /** An alternate label to use in place of the default "Convenience Fee" */
    convenienceFeeLabel?: string;
    /** The message to display next to the convenience fee item (via the "i" icon) */
    convenienceFeeNote?: string;
    /** What format the rate is stored as (percent, flat, other) */
    convenienceFeeFormat?: string;
    /** The rate the convenience fee is charged at
Stored as a represetation matching the format
e.g. 3% would be 0.03, $50 would be 50
If the rate is more complex, use format "other" and do not fill this out
 */
    convenienceFeeRate?: number;
    /** Determines whether or not dual entry of account and routing numbers are required when paying by E-Check. */
    requireDualEntryForECheck?: any;
    /** Whether to use VGS Collect iframe for echeck fields instead of the hardcoded echeck form. */
    useVgsForECheck?: boolean;
    /** Any additional data that is needed to be sent from the backend to frontend */
    additionalData?: { [key: string]: string; };
    /** Whether or not credit cards can be saved to pay with later via tokenization
  True: we will allow the user to select to store the CC for later use in which case
      we will store a token for later use
  False: the user will not get the option to store their CC payment method
 */
    supportsTokenization?: boolean;
    /** If this is a test environment, this may be populated with a test trigger which will appear
on the UI to allow a tester to trigger certain scenarios with the payment processor.
 */
    testTriggers?: { [key: string]: string; };
    /** List of accepted card brands for display in the UI (e.g., ["visa", "mastercard", "amex", "discover"]).
If not specified or empty, no card brand logos will be displayed.
 */
    acceptedCardBrands?: string[];
    /** Regular expression matching a SINGLE character the payment processor permits
in a billing name (e.g., "[A-Za-z0-9 ',.\-]"). Anything the pattern does not
match is rejected before submission. Null when the processor imposes no
restriction.
 */
    allowedBillingNameCharacterPattern?: string | undefined;
    /** Longest billing name the payment processor accepts (e.g., 100). Null when the
processor imposes no limit.
 */
    maxBillingNameLength?: number | undefined;

    [key: string]: any;
}

/** Identifies one cart partition by (Teller system, MID-override) — used to round-trip per-partition flags from prepare back to subsequent endpoints without re-probing. */
export class CartPartitionRefDto implements ICartPartitionRefDto {
    /** Teller system code for the partition. */
    tellerSystemCode!: string;
    /** MID-override key for the partition. Empty/null means default config. */
    paymentProcessorConfigKey?: string;

    [key: string]: any;

    constructor(data?: ICartPartitionRefDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tellerSystemCode = _data["tellerSystemCode"];
            this.paymentProcessorConfigKey = _data["paymentProcessorConfigKey"];
        }
    }

    static fromJS(data: any): CartPartitionRefDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartPartitionRefDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tellerSystemCode"] = this.tellerSystemCode;
        data["paymentProcessorConfigKey"] = this.paymentProcessorConfigKey;
        return data;
    }
}

/** Identifies one cart partition by (Teller system, MID-override) — used to round-trip per-partition flags from prepare back to subsequent endpoints without re-probing. */
export interface ICartPartitionRefDto {
    /** Teller system code for the partition. */
    tellerSystemCode: string;
    /** MID-override key for the partition. Empty/null means default config. */
    paymentProcessorConfigKey?: string;

    [key: string]: any;
}

/** One cart partition's session token minted during Prepare. Round-tripped from the prepare response → frontend → payCart so the per-partition session handle survives the API-call boundary and can be echoed on the partition's subsequent Authorize / Capture / CancelAuthorization (FIS-style propagation, but per-partition since Generic carts can fan out across plugins). */
export class CartPartitionSessionTokenDto implements ICartPartitionSessionTokenDto {
    /** Teller system code for the partition. */
    tellerSystemCode!: string;
    /** MID-override key for the partition. Empty/null means default config. */
    paymentProcessorConfigKey?: string;
    /** Opaque, plugin-defined session handle returned by Prepare for this partition. Echoed back as `sessionTokenData` on the partition's subsequent Authorize / Capture / CancelAuthorization wire request. */
    sessionTokenData?: string;

    [key: string]: any;

    constructor(data?: ICartPartitionSessionTokenDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tellerSystemCode = _data["tellerSystemCode"];
            this.paymentProcessorConfigKey = _data["paymentProcessorConfigKey"];
            this.sessionTokenData = _data["sessionTokenData"];
        }
    }

    static fromJS(data: any): CartPartitionSessionTokenDto {
        data = typeof data === 'object' ? data : {};
        let result = new CartPartitionSessionTokenDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tellerSystemCode"] = this.tellerSystemCode;
        data["paymentProcessorConfigKey"] = this.paymentProcessorConfigKey;
        data["sessionTokenData"] = this.sessionTokenData;
        return data;
    }
}

/** One cart partition's session token minted during Prepare. Round-tripped from the prepare response → frontend → payCart so the per-partition session handle survives the API-call boundary and can be echoed on the partition's subsequent Authorize / Capture / CancelAuthorization (FIS-style propagation, but per-partition since Generic carts can fan out across plugins). */
export interface ICartPartitionSessionTokenDto {
    /** Teller system code for the partition. */
    tellerSystemCode: string;
    /** MID-override key for the partition. Empty/null means default config. */
    paymentProcessorConfigKey?: string;
    /** Opaque, plugin-defined session handle returned by Prepare for this partition. Echoed back as `sessionTokenData` on the partition's subsequent Authorize / Capture / CancelAuthorization wire request. */
    sessionTokenData?: string;

    [key: string]: any;
}

/** Lazy re-tokenization request for a saved payment method against the partitions the latest prepare reported as needing it. Partitions are passed by the caller (round-tripped from the prepare response) so the endpoint doesn't re-probe Prepare. */
export class ReTokenizeSavedPaymentMethodRequestDto implements IReTokenizeSavedPaymentMethodRequestDto {
    /** Cart whose partitions drive the (system, plugin) fan-out for re-tokenization. */
    cartId!: number;
    /** The cart's own guid, required to confirm the caller
actually owns the cart addressed by cartId before reading its stored
processor token. A missing or mismatched value is rejected as
UnauthorizedAccess.
 */
    cartGuid!: string;
    /** Per-request short-lived CVV token from VGS for credit-card re-tokenization. PCI-scope; never persisted server-side. Null/omitted for echeck — the encrypted account number on the saved method is sufficient. */
    cvvToken?: string;
    /** The cart partitions reported as needing re-tokenization on the latest prepare response. The endpoint validates each entry is actually in the supplied cart, then mints a token per (system, plugin, MID) for the saved method's wallet id. */
    partitions!: CartPartitionRefDto[];

    [key: string]: any;

    constructor(data?: IReTokenizeSavedPaymentMethodRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.partitions = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cartId = _data["cartId"];
            this.cartGuid = _data["cartGuid"];
            this.cvvToken = _data["cvvToken"];
            if (Array.isArray(_data["partitions"])) {
                this.partitions = [] as any;
                for (let item of _data["partitions"])
                    this.partitions!.push(CartPartitionRefDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReTokenizeSavedPaymentMethodRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReTokenizeSavedPaymentMethodRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cartId"] = this.cartId;
        data["cartGuid"] = this.cartGuid;
        data["cvvToken"] = this.cvvToken;
        if (Array.isArray(this.partitions)) {
            data["partitions"] = [];
            for (let item of this.partitions)
                data["partitions"].push(item.toJSON());
        }
        return data;
    }
}

/** Lazy re-tokenization request for a saved payment method against the partitions the latest prepare reported as needing it. Partitions are passed by the caller (round-tripped from the prepare response) so the endpoint doesn't re-probe Prepare. */
export interface IReTokenizeSavedPaymentMethodRequestDto {
    /** Cart whose partitions drive the (system, plugin) fan-out for re-tokenization. */
    cartId: number;
    /** The cart's own guid, required to confirm the caller
actually owns the cart addressed by cartId before reading its stored
processor token. A missing or mismatched value is rejected as
UnauthorizedAccess.
 */
    cartGuid: string;
    /** Per-request short-lived CVV token from VGS for credit-card re-tokenization. PCI-scope; never persisted server-side. Null/omitted for echeck — the encrypted account number on the saved method is sufficient. */
    cvvToken?: string;
    /** The cart partitions reported as needing re-tokenization on the latest prepare response. The endpoint validates each entry is actually in the supplied cart, then mints a token per (system, plugin, MID) for the saved method's wallet id. */
    partitions: CartPartitionRefDto[];

    [key: string]: any;
}

/** Response to preparing a payment (but not submitting it) */
export class IFramePaymentPrepareResponseDto implements IIFramePaymentPrepareResponseDto {
    /** The token representing the payment. */
    paymentToken?: string;
    /** The total amount of the convenience fee. */
    convenienceFee?: number;
    /** The payment method type returned by the processor. */
    processorPaymentMethodType?: string;
    /** Cart partitions whose plugin reported `canProcessSavedPaymentMethod=false` for the saved method's wallet id. Empty when every partition can authorize directly. The frontend round-trips this verbatim to the re-tokenize endpoint when minting the missing token rows (passing a fresh CVV for credit; immediately for echeck) — no second Prepare probe. */
    partitionsNeedingReTokenize?: CartPartitionRefDto[];
    /** Per-partition session handles minted during Prepare. The frontend round-trips this list verbatim on the subsequent payCart payload so MakePayment can echo each partition's handle on its Authorize / Capture / CancelAuthorization wire call. Empty when no plugin initialized a session. */
    partitionSessionTokens?: CartPartitionSessionTokenDto[];
    /** Per-partition convenience fees minted by the plugin during Prepare. The frontend feeds this directly into `cartService.calculateTotals` so the totals row reflects prepare-time fees without a second `/convenience-fee/...` call. Reuses `ConvenienceFeeDto` shape since the frontend pipeline already consumes that type. */
    partitionConvenienceFees?: ConvenienceFeeDto[];

    [key: string]: any;

    constructor(data?: IIFramePaymentPrepareResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentToken = _data["paymentToken"];
            this.convenienceFee = _data["convenienceFee"];
            this.processorPaymentMethodType = _data["processorPaymentMethodType"];
            if (Array.isArray(_data["partitionsNeedingReTokenize"])) {
                this.partitionsNeedingReTokenize = [] as any;
                for (let item of _data["partitionsNeedingReTokenize"])
                    this.partitionsNeedingReTokenize!.push(CartPartitionRefDto.fromJS(item));
            }
            if (Array.isArray(_data["partitionSessionTokens"])) {
                this.partitionSessionTokens = [] as any;
                for (let item of _data["partitionSessionTokens"])
                    this.partitionSessionTokens!.push(CartPartitionSessionTokenDto.fromJS(item));
            }
            if (Array.isArray(_data["partitionConvenienceFees"])) {
                this.partitionConvenienceFees = [] as any;
                for (let item of _data["partitionConvenienceFees"])
                    this.partitionConvenienceFees!.push(ConvenienceFeeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IFramePaymentPrepareResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new IFramePaymentPrepareResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentToken"] = this.paymentToken;
        data["convenienceFee"] = this.convenienceFee;
        data["processorPaymentMethodType"] = this.processorPaymentMethodType;
        if (Array.isArray(this.partitionsNeedingReTokenize)) {
            data["partitionsNeedingReTokenize"] = [];
            for (let item of this.partitionsNeedingReTokenize)
                data["partitionsNeedingReTokenize"].push(item.toJSON());
        }
        if (Array.isArray(this.partitionSessionTokens)) {
            data["partitionSessionTokens"] = [];
            for (let item of this.partitionSessionTokens)
                data["partitionSessionTokens"].push(item.toJSON());
        }
        if (Array.isArray(this.partitionConvenienceFees)) {
            data["partitionConvenienceFees"] = [];
            for (let item of this.partitionConvenienceFees)
                data["partitionConvenienceFees"].push(item.toJSON());
        }
        return data;
    }
}

/** Response to preparing a payment (but not submitting it) */
export interface IIFramePaymentPrepareResponseDto {
    /** The token representing the payment. */
    paymentToken?: string;
    /** The total amount of the convenience fee. */
    convenienceFee?: number;
    /** The payment method type returned by the processor. */
    processorPaymentMethodType?: string;
    /** Cart partitions whose plugin reported `canProcessSavedPaymentMethod=false` for the saved method's wallet id. Empty when every partition can authorize directly. The frontend round-trips this verbatim to the re-tokenize endpoint when minting the missing token rows (passing a fresh CVV for credit; immediately for echeck) — no second Prepare probe. */
    partitionsNeedingReTokenize?: CartPartitionRefDto[];
    /** Per-partition session handles minted during Prepare. The frontend round-trips this list verbatim on the subsequent payCart payload so MakePayment can echo each partition's handle on its Authorize / Capture / CancelAuthorization wire call. Empty when no plugin initialized a session. */
    partitionSessionTokens?: CartPartitionSessionTokenDto[];
    /** Per-partition convenience fees minted by the plugin during Prepare. The frontend feeds this directly into `cartService.calculateTotals` so the totals row reflects prepare-time fees without a second `/convenience-fee/...` call. Reuses `ConvenienceFeeDto` shape since the frontend pipeline already consumes that type. */
    partitionConvenienceFees?: ConvenienceFeeDto[];

    [key: string]: any;
}

export class FisPaymentDetailsRequestDto implements IFisPaymentDetailsRequestDto {
    /** The guid of the cart to generate details for */
    cartGuid!: string;
    /** The token returned from the captcha widget */
    captchaToken!: string | undefined;

    [key: string]: any;

    constructor(data?: IFisPaymentDetailsRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cartGuid = _data["cartGuid"];
            this.captchaToken = _data["captchaToken"];
        }
    }

    static fromJS(data: any): FisPaymentDetailsRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new FisPaymentDetailsRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cartGuid"] = this.cartGuid;
        data["captchaToken"] = this.captchaToken;
        return data;
    }
}

export interface IFisPaymentDetailsRequestDto {
    /** The guid of the cart to generate details for */
    cartGuid: string;
    /** The token returned from the captcha widget */
    captchaToken: string | undefined;

    [key: string]: any;
}

/** The lineItems and userParts that need to be passed to the MultiPay iFrame */
export class FisPaymentDetailsResponseDto implements IFisPaymentDetailsResponseDto {
    /** The line items to be passed to the MultiPay iFrame for payment */
    lineItems?: FisLineItemDto[];
    /** A set of up to 6 user parts to be passed to the MultiPay iFrame for payment */
    userParts?: FisUserPartDto[];

    [key: string]: any;

    constructor(data?: IFisPaymentDetailsResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            if (Array.isArray(_data["lineItems"])) {
                this.lineItems = [] as any;
                for (let item of _data["lineItems"])
                    this.lineItems!.push(FisLineItemDto.fromJS(item));
            }
            if (Array.isArray(_data["userParts"])) {
                this.userParts = [] as any;
                for (let item of _data["userParts"])
                    this.userParts!.push(FisUserPartDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FisPaymentDetailsResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new FisPaymentDetailsResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        if (Array.isArray(this.lineItems)) {
            data["lineItems"] = [];
            for (let item of this.lineItems)
                data["lineItems"].push(item.toJSON());
        }
        if (Array.isArray(this.userParts)) {
            data["userParts"] = [];
            for (let item of this.userParts)
                data["userParts"].push(item.toJSON());
        }
        return data;
    }
}

/** The lineItems and userParts that need to be passed to the MultiPay iFrame */
export interface IFisPaymentDetailsResponseDto {
    /** The line items to be passed to the MultiPay iFrame for payment */
    lineItems?: FisLineItemDto[];
    /** A set of up to 6 user parts to be passed to the MultiPay iFrame for payment */
    userParts?: FisUserPartDto[];

    [key: string]: any;
}

/** A line item to be passed to the MultiPay iFrame for payment */
export class FisLineItemDto implements IFisLineItemDto {
    /** The amount (price) of the line item */
    amount?: number;
    /** The quantity of times this specific line item is to be paid for */
    quantity?: number;
    /** The description of the line item */
    name?: string;
    /** A set of up to 6 user parts to be passed to the MultiPay iFrame for payment */
    userParts?: FisUserPartDto[];

    [key: string]: any;

    constructor(data?: IFisLineItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.amount = _data["amount"];
            this.quantity = _data["quantity"];
            this.name = _data["name"];
            if (Array.isArray(_data["userParts"])) {
                this.userParts = [] as any;
                for (let item of _data["userParts"])
                    this.userParts!.push(FisUserPartDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FisLineItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new FisLineItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["amount"] = this.amount;
        data["quantity"] = this.quantity;
        data["name"] = this.name;
        if (Array.isArray(this.userParts)) {
            data["userParts"] = [];
            for (let item of this.userParts)
                data["userParts"].push(item.toJSON());
        }
        return data;
    }
}

/** A line item to be passed to the MultiPay iFrame for payment */
export interface IFisLineItemDto {
    /** The amount (price) of the line item */
    amount?: number;
    /** The quantity of times this specific line item is to be paid for */
    quantity?: number;
    /** The description of the line item */
    name?: string;
    /** A set of up to 6 user parts to be passed to the MultiPay iFrame for payment */
    userParts?: FisUserPartDto[];

    [key: string]: any;
}

/** A user part to be passed to the MultiPay iFrame for payment */
export class FisUserPartDto implements IFisUserPartDto {
    /** The user part number (1-6) */
    number?: string;
    /** The value for the user part */
    value?: string;

    [key: string]: any;

    constructor(data?: IFisUserPartDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.number = _data["number"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): FisUserPartDto {
        data = typeof data === 'object' ? data : {};
        let result = new FisUserPartDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["number"] = this.number;
        data["value"] = this.value;
        return data;
    }
}

/** A user part to be passed to the MultiPay iFrame for payment */
export interface IFisUserPartDto {
    /** The user part number (1-6) */
    number?: string;
    /** The value for the user part */
    value?: string;

    [key: string]: any;
}

export class NicVerifyPaymentStatusRequestDto implements INicVerifyPaymentStatusRequestDto {
    /** Token provided from the payment integrator */
    token!: string;
    /** Guid association with the cart */
    paymentIdentifier!: string;
    /** Status of the payment request as provided on the post-back URL */
    paymentStatus!: NicPaymentStatusEnum;

    [key: string]: any;

    constructor(data?: INicVerifyPaymentStatusRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
            this.paymentIdentifier = _data["paymentIdentifier"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): NicVerifyPaymentStatusRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new NicVerifyPaymentStatusRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        data["paymentIdentifier"] = this.paymentIdentifier;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface INicVerifyPaymentStatusRequestDto {
    /** Token provided from the payment integrator */
    token: string;
    /** Guid association with the cart */
    paymentIdentifier: string;
    /** Status of the payment request as provided on the post-back URL */
    paymentStatus: NicPaymentStatusEnum;

    [key: string]: any;
}

/** Response from backend of handling a postback from processor */
export class RedirectPaymentProcessorPaymentResponseDto implements IRedirectPaymentProcessorPaymentResponseDto {
    /** Status of the payment request */
    paymentStatus!: any;
    /** Email address where the receipt is mailed. */
    emailAddress?: string;
    /** Unique identifier for the cart. */
    cartGuid?: string;

    [key: string]: any;

    constructor(data?: IRedirectPaymentProcessorPaymentResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentStatus = _data["paymentStatus"];
            this.emailAddress = _data["emailAddress"];
            this.cartGuid = _data["cartGuid"];
        }
    }

    static fromJS(data: any): RedirectPaymentProcessorPaymentResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectPaymentProcessorPaymentResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentStatus"] = this.paymentStatus;
        data["emailAddress"] = this.emailAddress;
        data["cartGuid"] = this.cartGuid;
        return data;
    }
}

/** Response from backend of handling a postback from processor */
export interface IRedirectPaymentProcessorPaymentResponseDto {
    /** Status of the payment request */
    paymentStatus: any;
    /** Email address where the receipt is mailed. */
    emailAddress?: string;
    /** Unique identifier for the cart. */
    cartGuid?: string;

    [key: string]: any;
}

/** Response from NicController of handling a postback from NIC */
export class NicVerifyPaymentStatusResponseDto extends RedirectPaymentProcessorPaymentResponseDto implements INicVerifyPaymentStatusResponseDto {
    /** Status of the payment request */
    paymentStatus!: NicPaymentStatusEnum;

    [key: string]: any;

    constructor(data?: INicVerifyPaymentStatusResponseDto) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): NicVerifyPaymentStatusResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new NicVerifyPaymentStatusResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["paymentStatus"] = this.paymentStatus;
        super.toJSON(data);
        return data;
    }
}

/** Response from NicController of handling a postback from NIC */
export interface INicVerifyPaymentStatusResponseDto extends IRedirectPaymentProcessorPaymentResponseDto {
    /** Status of the payment request */
    paymentStatus: NicPaymentStatusEnum;

    [key: string]: any;
}

/** Response containing session token. */
export class SessionTokenResponseDto implements ISessionTokenResponseDto {
    /** The generated token. Will be null if token could not be generated. */
    token?: string;

    [key: string]: any;

    constructor(data?: ISessionTokenResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.token = _data["token"];
        }
    }

    static fromJS(data: any): SessionTokenResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new SessionTokenResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["token"] = this.token;
        return data;
    }
}

/** Response containing session token. */
export interface ISessionTokenResponseDto {
    /** The generated token. Will be null if token could not be generated. */
    token?: string;

    [key: string]: any;
}

export enum NicPaymentStatusEnum {
    Success = "success",
    Failure = "failure",
    Duplicate = "duplicate",
    Cancelled = "cancelled",
}

export class RedirectVerifyPaymentStatusRequestDto implements IRedirectVerifyPaymentStatusRequestDto {
    /** Ref provided from the payment integrator */
    ref?: string;
    /** Unique identifier association with the payment */
    paymentIdentifier!: string;
    /** Status of the payment request as provided on the post-back URL */
    paymentStatus!: RedirectPaymentStatusEnum;

    [key: string]: any;

    constructor(data?: IRedirectVerifyPaymentStatusRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.ref = _data["ref"];
            this.paymentIdentifier = _data["paymentIdentifier"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): RedirectVerifyPaymentStatusRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectVerifyPaymentStatusRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["ref"] = this.ref;
        data["paymentIdentifier"] = this.paymentIdentifier;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface IRedirectVerifyPaymentStatusRequestDto {
    /** Ref provided from the payment integrator */
    ref?: string;
    /** Unique identifier association with the payment */
    paymentIdentifier: string;
    /** Status of the payment request as provided on the post-back URL */
    paymentStatus: RedirectPaymentStatusEnum;

    [key: string]: any;
}

/** Response from backend of handling a postback from processor */
export class RedirectVerifyPaymentStatusResponseDto implements IRedirectVerifyPaymentStatusResponseDto {
    /** Guid of the cart whose payment was verified. The frontend should
use this rather than its own stored cartGuid because the postback
arrives via an external redirect and the frontend session may have
lost track of the active cart.
 */
    cartGuid?: string;
    /** Email address where the receipt is mailed. */
    emailAddress?: string;
    /** True if the payment succeeded, false otherwise */
    responseSuccess!: any;
    /** The error message corresponding to a failed payment */
    responseMessage?: string;

    [key: string]: any;

    constructor(data?: IRedirectVerifyPaymentStatusResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cartGuid = _data["cartGuid"];
            this.emailAddress = _data["emailAddress"];
            this.responseSuccess = _data["responseSuccess"];
            this.responseMessage = _data["responseMessage"];
        }
    }

    static fromJS(data: any): RedirectVerifyPaymentStatusResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectVerifyPaymentStatusResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cartGuid"] = this.cartGuid;
        data["emailAddress"] = this.emailAddress;
        data["responseSuccess"] = this.responseSuccess;
        data["responseMessage"] = this.responseMessage;
        return data;
    }
}

/** Response from backend of handling a postback from processor */
export interface IRedirectVerifyPaymentStatusResponseDto {
    /** Guid of the cart whose payment was verified. The frontend should
use this rather than its own stored cartGuid because the postback
arrives via an external redirect and the frontend session may have
lost track of the active cart.
 */
    cartGuid?: string;
    /** Email address where the receipt is mailed. */
    emailAddress?: string;
    /** True if the payment succeeded, false otherwise */
    responseSuccess: any;
    /** The error message corresponding to a failed payment */
    responseMessage?: string;

    [key: string]: any;
}

/** Authoritative base amount, convenience fee, and total for a wallet payment. Returned by GET /wallet-payments/{cartGuid}/amount so the frontend can open the wallet sheet with the server's exact values. */
export class WalletPaymentAmountDto implements IWalletPaymentAmountDto {
    /** Cart subtotal before the convenience fee. */
    baseAmount?: number;
    /** Convenience fee computed at the credit-card rail. */
    convenienceFee?: number;
    /** baseAmount + convenienceFee — the amount to bind to the cryptogram. */
    total?: number;

    [key: string]: any;

    constructor(data?: IWalletPaymentAmountDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.baseAmount = _data["baseAmount"];
            this.convenienceFee = _data["convenienceFee"];
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): WalletPaymentAmountDto {
        data = typeof data === 'object' ? data : {};
        let result = new WalletPaymentAmountDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["baseAmount"] = this.baseAmount;
        data["convenienceFee"] = this.convenienceFee;
        data["total"] = this.total;
        return data;
    }
}

/** Authoritative base amount, convenience fee, and total for a wallet payment. Returned by GET /wallet-payments/{cartGuid}/amount so the frontend can open the wallet sheet with the server's exact values. */
export interface IWalletPaymentAmountDto {
    /** Cart subtotal before the convenience fee. */
    baseAmount?: number;
    /** Convenience fee computed at the credit-card rail. */
    convenienceFee?: number;
    /** baseAmount + convenienceFee — the amount to bind to the cryptogram. */
    total?: number;

    [key: string]: any;
}

export class WalletPaymentRequestDto implements IWalletPaymentRequestDto {
    /** Unique ID of the cart being paid. */
    cartId!: number;
    /** The cart's own guid, required to confirm the caller
actually owns the cart addressed by cartId before charging or tokenizing
against it. A missing or mismatched value is rejected as UnauthorizedAccess.
 */
    cartGuid!: string;
    /** Token from the reCAPTCHA widget. */
    captchaToken?: string | undefined;
    /** Wallet flavor for this payment. */
    digitalWalletType!: DigitalWalletTypeEnumDto;
    /** Encrypted wallet payload from the provider's JS API (Apple Pay
payment.token JSON or Google Pay tokenizationData.token).
Single-use per EMVCo spec — server tokenizes and discards.
 */
    encryptedPayload!: string;
    /** Convenience fee total (across all partitions) the frontend showed
the user in the wallet sheet, and that is therefore baked into the
EMVCo cryptogram amount. Server recomputes the fee at auth time
and rejects the payment with WalletFeeMismatch if the recomputed
value differs from this — the cryptogram is bound to a single
amount, so paying a different amount than authorized would be a
protocol violation. Sum across partitions in cents-precision
($0.01 tolerance applied server-side).
 */
    expectedFee!: number;
    /** Full name from the wallet billing address. */
    fullName?: string;
    addressLine1?: string;
    addressLine2?: string;
    addressCity?: string;
    addressState?: string;
    addressStateCode?: string;
    addressZip?: string;
    addressCountry?: string;
    addressCountryCode?: string;
    phone?: string;
    email?: string;
    last4?: string;
    cardType?: string;

    [key: string]: any;

    constructor(data?: IWalletPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cartId = _data["cartId"];
            this.cartGuid = _data["cartGuid"];
            this.captchaToken = _data["captchaToken"];
            this.digitalWalletType = _data["digitalWalletType"];
            this.encryptedPayload = _data["encryptedPayload"];
            this.expectedFee = _data["expectedFee"];
            this.fullName = _data["fullName"];
            this.addressLine1 = _data["addressLine1"];
            this.addressLine2 = _data["addressLine2"];
            this.addressCity = _data["addressCity"];
            this.addressState = _data["addressState"];
            this.addressStateCode = _data["addressStateCode"];
            this.addressZip = _data["addressZip"];
            this.addressCountry = _data["addressCountry"];
            this.addressCountryCode = _data["addressCountryCode"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.last4 = _data["last4"];
            this.cardType = _data["cardType"];
        }
    }

    static fromJS(data: any): WalletPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new WalletPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cartId"] = this.cartId;
        data["cartGuid"] = this.cartGuid;
        data["captchaToken"] = this.captchaToken;
        data["digitalWalletType"] = this.digitalWalletType;
        data["encryptedPayload"] = this.encryptedPayload;
        data["expectedFee"] = this.expectedFee;
        data["fullName"] = this.fullName;
        data["addressLine1"] = this.addressLine1;
        data["addressLine2"] = this.addressLine2;
        data["addressCity"] = this.addressCity;
        data["addressState"] = this.addressState;
        data["addressStateCode"] = this.addressStateCode;
        data["addressZip"] = this.addressZip;
        data["addressCountry"] = this.addressCountry;
        data["addressCountryCode"] = this.addressCountryCode;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["last4"] = this.last4;
        data["cardType"] = this.cardType;
        return data;
    }
}

export interface IWalletPaymentRequestDto {
    /** Unique ID of the cart being paid. */
    cartId: number;
    /** The cart's own guid, required to confirm the caller
actually owns the cart addressed by cartId before charging or tokenizing
against it. A missing or mismatched value is rejected as UnauthorizedAccess.
 */
    cartGuid: string;
    /** Token from the reCAPTCHA widget. */
    captchaToken?: string | undefined;
    /** Wallet flavor for this payment. */
    digitalWalletType: DigitalWalletTypeEnumDto;
    /** Encrypted wallet payload from the provider's JS API (Apple Pay
payment.token JSON or Google Pay tokenizationData.token).
Single-use per EMVCo spec — server tokenizes and discards.
 */
    encryptedPayload: string;
    /** Convenience fee total (across all partitions) the frontend showed
the user in the wallet sheet, and that is therefore baked into the
EMVCo cryptogram amount. Server recomputes the fee at auth time
and rejects the payment with WalletFeeMismatch if the recomputed
value differs from this — the cryptogram is bound to a single
amount, so paying a different amount than authorized would be a
protocol violation. Sum across partitions in cents-precision
($0.01 tolerance applied server-side).
 */
    expectedFee: number;
    /** Full name from the wallet billing address. */
    fullName?: string;
    addressLine1?: string;
    addressLine2?: string;
    addressCity?: string;
    addressState?: string;
    addressStateCode?: string;
    addressZip?: string;
    addressCountry?: string;
    addressCountryCode?: string;
    phone?: string;
    email?: string;
    last4?: string;
    cardType?: string;

    [key: string]: any;
}

export class ApplePayMerchantValidationRequestDto implements IApplePayMerchantValidationRequestDto {
    /** Apple-provided merchant validation URL from the onvalidatemerchant callback. */
    validationUrl!: string;
    /** Hostname of the page initiating the Apple Pay session. */
    domainName!: string;
    /** Cart context. Required for Generic-routed tenants: the cart's single
partition determines which plugin's merchant certificate signs the
validation. Non-Generic integrators (Fiserv etc.) ignore this and use
the tenant-level cert.
 */
    cartId?: number | undefined;
    /** The cart's own guid, required alongside cartId when
cartId is supplied - confirms the caller actually owns the addressed cart.
 */
    cartGuid?: string | undefined;

    [key: string]: any;

    constructor(data?: IApplePayMerchantValidationRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.validationUrl = _data["validationUrl"];
            this.domainName = _data["domainName"];
            this.cartId = _data["cartId"];
            this.cartGuid = _data["cartGuid"];
        }
    }

    static fromJS(data: any): ApplePayMerchantValidationRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplePayMerchantValidationRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["validationUrl"] = this.validationUrl;
        data["domainName"] = this.domainName;
        data["cartId"] = this.cartId;
        data["cartGuid"] = this.cartGuid;
        return data;
    }
}

export interface IApplePayMerchantValidationRequestDto {
    /** Apple-provided merchant validation URL from the onvalidatemerchant callback. */
    validationUrl: string;
    /** Hostname of the page initiating the Apple Pay session. */
    domainName: string;
    /** Cart context. Required for Generic-routed tenants: the cart's single
partition determines which plugin's merchant certificate signs the
validation. Non-Generic integrators (Fiserv etc.) ignore this and use
the tenant-level cert.
 */
    cartId?: number | undefined;
    /** The cart's own guid, required alongside cartId when
cartId is supplied - confirms the caller actually owns the addressed cart.
 */
    cartGuid?: string | undefined;

    [key: string]: any;
}

export class ApplePayMerchantValidationResponseDto implements IApplePayMerchantValidationResponseDto {
    /** True when Apple's validation succeeded. */
    success!: boolean;
    /** Apple-signed merchant session JSON. Passed verbatim back to the
Apple Pay JS API via session.completeMerchantValidation().
 */
    merchantSession?: string | undefined;
    /** Error message when validation failed. */
    errorMessage?: string | undefined;

    [key: string]: any;

    constructor(data?: IApplePayMerchantValidationResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.success = _data["success"];
            this.merchantSession = _data["merchantSession"];
            this.errorMessage = _data["errorMessage"];
        }
    }

    static fromJS(data: any): ApplePayMerchantValidationResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplePayMerchantValidationResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["success"] = this.success;
        data["merchantSession"] = this.merchantSession;
        data["errorMessage"] = this.errorMessage;
        return data;
    }
}

export interface IApplePayMerchantValidationResponseDto {
    /** True when Apple's validation succeeded. */
    success: boolean;
    /** Apple-signed merchant session JSON. Passed verbatim back to the
Apple Pay JS API via session.completeMerchantValidation().
 */
    merchantSession?: string | undefined;
    /** Error message when validation failed. */
    errorMessage?: string | undefined;

    [key: string]: any;
}

export class FisVerifyPaymentRequestDto implements IFisVerifyPaymentRequestDto {
    /** The cart GUID of the cart to verify payment for */
    cartGuid!: string;
    /** The idendifier of the payment to verify */
    paymentIdentifier!: string;
    /** The payment ID returned from the MultiPay iFrame */
    paymentId!: string | undefined;
    /** The email address entered during payment, will be used to send a receipt */
    email?: string;
    /** Last 4 digits of card being used to pay */
    last4?: string;
    /** Values returned from FIS, examples are -- Visa, Mastercard, Discover, or American Express */
    cardType?: string;
    /** Mix of values from FIS, will be either the same as cardType, or "Debit" or "Bank" */
    processorPaymentMethodType?: string;
    /** User's affirmative consent to the AdHoc authorization text shown on
the checkout page (TOP-2935). The FIS MultiPay iFrame charges the
payment client-side, so this verify call is where the backend
validates and records the consent for the resulting Payment. Required
for ECheck; for Credit, required only when an active authorization
text resolves. Null on the failure-recovery verify (no fresh user
authorization), which does not require consent.
 */
    authorizationConsent?: AuthorizationConsentDto;

    [key: string]: any;

    constructor(data?: IFisVerifyPaymentRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.cartGuid = _data["cartGuid"];
            this.paymentIdentifier = _data["paymentIdentifier"];
            this.paymentId = _data["paymentId"];
            this.email = _data["email"];
            this.last4 = _data["last4"];
            this.cardType = _data["cardType"];
            this.processorPaymentMethodType = _data["processorPaymentMethodType"];
            this.authorizationConsent = _data["authorizationConsent"] ? AuthorizationConsentDto.fromJS(_data["authorizationConsent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FisVerifyPaymentRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new FisVerifyPaymentRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["cartGuid"] = this.cartGuid;
        data["paymentIdentifier"] = this.paymentIdentifier;
        data["paymentId"] = this.paymentId;
        data["email"] = this.email;
        data["last4"] = this.last4;
        data["cardType"] = this.cardType;
        data["processorPaymentMethodType"] = this.processorPaymentMethodType;
        data["authorizationConsent"] = this.authorizationConsent ? this.authorizationConsent.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFisVerifyPaymentRequestDto {
    /** The cart GUID of the cart to verify payment for */
    cartGuid: string;
    /** The idendifier of the payment to verify */
    paymentIdentifier: string;
    /** The payment ID returned from the MultiPay iFrame */
    paymentId: string | undefined;
    /** The email address entered during payment, will be used to send a receipt */
    email?: string;
    /** Last 4 digits of card being used to pay */
    last4?: string;
    /** Values returned from FIS, examples are -- Visa, Mastercard, Discover, or American Express */
    cardType?: string;
    /** Mix of values from FIS, will be either the same as cardType, or "Debit" or "Bank" */
    processorPaymentMethodType?: string;
    /** User's affirmative consent to the AdHoc authorization text shown on
the checkout page (TOP-2935). The FIS MultiPay iFrame charges the
payment client-side, so this verify call is where the backend
validates and records the consent for the resulting Payment. Required
for ECheck; for Credit, required only when an active authorization
text resolves. Null on the failure-recovery verify (no fresh user
authorization), which does not require consent.
 */
    authorizationConsent?: AuthorizationConsentDto;

    [key: string]: any;
}

export enum RedirectPaymentStatusEnum {
    Success = "success",
    Failure = "failure",
    Duplicate = "duplicate",
    Cancelled = "cancelled",
}

/** Initialization data for Generic PSP */
export class GenericInitializeDto implements IGenericInitializeDto {
    /** vgs vault id */
    vaultId?: string;
    /** vgs environment */
    environment?: string;
    /** vgs api version */
    version?: string;

    [key: string]: any;

    constructor(data?: IGenericInitializeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.vaultId = _data["vaultId"];
            this.environment = _data["environment"];
            this.version = _data["version"];
        }
    }

    static fromJS(data: any): GenericInitializeDto {
        data = typeof data === 'object' ? data : {};
        let result = new GenericInitializeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["vaultId"] = this.vaultId;
        data["environment"] = this.environment;
        data["version"] = this.version;
        return data;
    }
}

/** Initialization data for Generic PSP */
export interface IGenericInitializeDto {
    /** vgs vault id */
    vaultId?: string;
    /** vgs environment */
    environment?: string;
    /** vgs api version */
    version?: string;

    [key: string]: any;
}

/** Aggregated plugin configuration for a cart. Cart-wide invariants (isRedirect, useVGSForEchecks, createsNewPaymentOnPrepare) are validated to match across every (system, plugin) pair in the cart's partition set; UI requirement flags are OR-merged (most-strict wins); per-(system, plugin) labels are listed individually in systemPluginLabels. */
export class AggregatedPluginConfigDto implements IAggregatedPluginConfigDto {
    /** True if the plugins use a redirect flow rather than in-line tokenization. */
    isRedirect!: boolean;
    /** True if eChecks are tokenized via VGS Collect. */
    useVGSForEchecks!: boolean;
    /** True if Prepare must create a fresh Payment row each call (FIS-style) rather than reuse the in-flight PreProcessing row. */
    createsNewPaymentOnPrepare!: boolean;
    /** True if billing address line 1 is required at checkout. */
    requireAddressLine1!: boolean;
    /** True if billing city is required. */
    requireCity!: boolean;
    /** True if billing state / province is required. */
    requireState!: boolean;
    /** True if billing country is required. */
    requireCountry!: boolean;
    /** True if payer phone number is required. */
    requirePhone!: boolean;
    /** True if the eCheck account-type field (checking / savings) is shown. */
    enableECheckAccountType!: boolean;
    /** True if the eCheck account-owner-type field (personal / business) is shown. */
    enableECheckAccountOwnerType!: boolean;
    /** True if any partition's plugin requires the payer to enter routing + account numbers twice for confirmation. */
    requireDualEntryForECheck!: boolean;
    /** Per-(system, plugin) labels for the cart's partition set. */
    systemPluginLabels!: SystemPluginLabelsDto[];

    [key: string]: any;

    constructor(data?: IAggregatedPluginConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.systemPluginLabels = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.isRedirect = _data["isRedirect"];
            this.useVGSForEchecks = _data["useVGSForEchecks"];
            this.createsNewPaymentOnPrepare = _data["createsNewPaymentOnPrepare"];
            this.requireAddressLine1 = _data["requireAddressLine1"];
            this.requireCity = _data["requireCity"];
            this.requireState = _data["requireState"];
            this.requireCountry = _data["requireCountry"];
            this.requirePhone = _data["requirePhone"];
            this.enableECheckAccountType = _data["enableECheckAccountType"];
            this.enableECheckAccountOwnerType = _data["enableECheckAccountOwnerType"];
            this.requireDualEntryForECheck = _data["requireDualEntryForECheck"];
            if (Array.isArray(_data["systemPluginLabels"])) {
                this.systemPluginLabels = [] as any;
                for (let item of _data["systemPluginLabels"])
                    this.systemPluginLabels!.push(SystemPluginLabelsDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AggregatedPluginConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new AggregatedPluginConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["isRedirect"] = this.isRedirect;
        data["useVGSForEchecks"] = this.useVGSForEchecks;
        data["createsNewPaymentOnPrepare"] = this.createsNewPaymentOnPrepare;
        data["requireAddressLine1"] = this.requireAddressLine1;
        data["requireCity"] = this.requireCity;
        data["requireState"] = this.requireState;
        data["requireCountry"] = this.requireCountry;
        data["requirePhone"] = this.requirePhone;
        data["enableECheckAccountType"] = this.enableECheckAccountType;
        data["enableECheckAccountOwnerType"] = this.enableECheckAccountOwnerType;
        data["requireDualEntryForECheck"] = this.requireDualEntryForECheck;
        if (Array.isArray(this.systemPluginLabels)) {
            data["systemPluginLabels"] = [];
            for (let item of this.systemPluginLabels)
                data["systemPluginLabels"].push(item.toJSON());
        }
        return data;
    }
}

/** Aggregated plugin configuration for a cart. Cart-wide invariants (isRedirect, useVGSForEchecks, createsNewPaymentOnPrepare) are validated to match across every (system, plugin) pair in the cart's partition set; UI requirement flags are OR-merged (most-strict wins); per-(system, plugin) labels are listed individually in systemPluginLabels. */
export interface IAggregatedPluginConfigDto {
    /** True if the plugins use a redirect flow rather than in-line tokenization. */
    isRedirect: boolean;
    /** True if eChecks are tokenized via VGS Collect. */
    useVGSForEchecks: boolean;
    /** True if Prepare must create a fresh Payment row each call (FIS-style) rather than reuse the in-flight PreProcessing row. */
    createsNewPaymentOnPrepare: boolean;
    /** True if billing address line 1 is required at checkout. */
    requireAddressLine1: boolean;
    /** True if billing city is required. */
    requireCity: boolean;
    /** True if billing state / province is required. */
    requireState: boolean;
    /** True if billing country is required. */
    requireCountry: boolean;
    /** True if payer phone number is required. */
    requirePhone: boolean;
    /** True if the eCheck account-type field (checking / savings) is shown. */
    enableECheckAccountType: boolean;
    /** True if the eCheck account-owner-type field (personal / business) is shown. */
    enableECheckAccountOwnerType: boolean;
    /** True if any partition's plugin requires the payer to enter routing + account numbers twice for confirmation. */
    requireDualEntryForECheck: boolean;
    /** Per-(system, plugin) labels for the cart's partition set. */
    systemPluginLabels: SystemPluginLabelsDto[];

    [key: string]: any;
}

/** Display labels for a single (system, plugin) pair on the cart. */
export class SystemPluginLabelsDto implements ISystemPluginLabelsDto {
    /** TellerConnectionConfigNo identifying the system this entry applies to. */
    systemConfigNo!: number;
    /** Plugin number identifying the PSP plugin this entry applies to. */
    pluginNumber!: number;
    /** PSP display name for use in logs, cart events, and admin UI. */
    displayName?: string;
    /** Custom-value name under which this plugin stores the PSP's transaction id. */
    transactionNoCustomValueName?: string;
    /** Custom-value name under which this plugin stores the convenience fee. */
    convenienceFeeCustomValueName?: string;

    [key: string]: any;

    constructor(data?: ISystemPluginLabelsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.systemConfigNo = _data["systemConfigNo"];
            this.pluginNumber = _data["pluginNumber"];
            this.displayName = _data["displayName"];
            this.transactionNoCustomValueName = _data["transactionNoCustomValueName"];
            this.convenienceFeeCustomValueName = _data["convenienceFeeCustomValueName"];
        }
    }

    static fromJS(data: any): SystemPluginLabelsDto {
        data = typeof data === 'object' ? data : {};
        let result = new SystemPluginLabelsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["systemConfigNo"] = this.systemConfigNo;
        data["pluginNumber"] = this.pluginNumber;
        data["displayName"] = this.displayName;
        data["transactionNoCustomValueName"] = this.transactionNoCustomValueName;
        data["convenienceFeeCustomValueName"] = this.convenienceFeeCustomValueName;
        return data;
    }
}

/** Display labels for a single (system, plugin) pair on the cart. */
export interface ISystemPluginLabelsDto {
    /** TellerConnectionConfigNo identifying the system this entry applies to. */
    systemConfigNo: number;
    /** Plugin number identifying the PSP plugin this entry applies to. */
    pluginNumber: number;
    /** PSP display name for use in logs, cart events, and admin UI. */
    displayName?: string;
    /** Custom-value name under which this plugin stores the PSP's transaction id. */
    transactionNoCustomValueName?: string;
    /** Custom-value name under which this plugin stores the convenience fee. */
    convenienceFeeCustomValueName?: string;

    [key: string]: any;
}

/** Wallet SDK configuration for one (tellerSystemCode, configKey) combination. The frontend matches the current partition's two keys to find its entry. Empty googlePayConfig and applePayConfig are both null (entry is never emitted when both wallets are absent for a combination). */
export class WalletCapabilityEntryDto implements IWalletCapabilityEntryDto {
    /** Lowercase TellerSystemCode for this entry.
Null for non-Generic processors or when the capability applies
to all systems.
 */
    tellerSystemCode?: string | undefined;
    /** PaymentProcessorConfigKey (MID override) for this entry.
Null means the default config (no override).
 */
    configKey?: string | undefined;
    googlePayConfig?: GooglePayConfigDto | undefined;
    applePayConfig?: ApplePayConfigDto | undefined;

    [key: string]: any;

    constructor(data?: IWalletCapabilityEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.tellerSystemCode = _data["tellerSystemCode"];
            this.configKey = _data["configKey"];
            this.googlePayConfig = _data["googlePayConfig"] ? GooglePayConfigDto.fromJS(_data["googlePayConfig"]) : <any>undefined;
            this.applePayConfig = _data["applePayConfig"] ? ApplePayConfigDto.fromJS(_data["applePayConfig"]) : <any>undefined;
        }
    }

    static fromJS(data: any): WalletCapabilityEntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new WalletCapabilityEntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["tellerSystemCode"] = this.tellerSystemCode;
        data["configKey"] = this.configKey;
        data["googlePayConfig"] = this.googlePayConfig ? this.googlePayConfig.toJSON() : <any>undefined;
        data["applePayConfig"] = this.applePayConfig ? this.applePayConfig.toJSON() : <any>undefined;
        return data;
    }
}

/** Wallet SDK configuration for one (tellerSystemCode, configKey) combination. The frontend matches the current partition's two keys to find its entry. Empty googlePayConfig and applePayConfig are both null (entry is never emitted when both wallets are absent for a combination). */
export interface IWalletCapabilityEntryDto {
    /** Lowercase TellerSystemCode for this entry.
Null for non-Generic processors or when the capability applies
to all systems.
 */
    tellerSystemCode?: string | undefined;
    /** PaymentProcessorConfigKey (MID override) for this entry.
Null means the default config (no override).
 */
    configKey?: string | undefined;
    googlePayConfig?: GooglePayConfigDto | undefined;
    applePayConfig?: ApplePayConfigDto | undefined;

    [key: string]: any;
}

/** Typed Google Pay configuration returned on PaymentConfigDto. Holds the merchant identity and network settings the Google Pay JS API needs to render the payment sheet. Single source of truth for both legacy tenant-level (Fiserv) and plugin-driven (Generic) flows. */
export class GooglePayConfigDto implements IGooglePayConfigDto {
    /** True when Google Pay is offered for this tenant / plugin pair. */
    enabled!: boolean;
    /** Google Pay environment - TEST or PRODUCTION. */
    environment?: string;
    /** Google Pay merchant id (e.g. BCR2DN...). */
    merchantId?: string;
    /** Merchant name shown in the Google Pay sheet. */
    merchantName?: string;
    /** PSP gateway identifier (e.g. "cardconnect"). */
    gateway?: string;
    /** PSP-specific gateway merchant id used to encrypt the token to the PSP. */
    gatewayMerchantId?: string;
    /** Allowed card networks - VISA, MASTERCARD, AMEX, DISCOVER, etc. */
    allowedCardNetworks?: string[];
    /** Allowed auth methods - PAN_ONLY, CRYPTOGRAM_3DS. */
    allowedAuthMethods?: string[];

    [key: string]: any;

    constructor(data?: IGooglePayConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.enabled = _data["enabled"];
            this.environment = _data["environment"];
            this.merchantId = _data["merchantId"];
            this.merchantName = _data["merchantName"];
            this.gateway = _data["gateway"];
            this.gatewayMerchantId = _data["gatewayMerchantId"];
            if (Array.isArray(_data["allowedCardNetworks"])) {
                this.allowedCardNetworks = [] as any;
                for (let item of _data["allowedCardNetworks"])
                    this.allowedCardNetworks!.push(item);
            }
            if (Array.isArray(_data["allowedAuthMethods"])) {
                this.allowedAuthMethods = [] as any;
                for (let item of _data["allowedAuthMethods"])
                    this.allowedAuthMethods!.push(item);
            }
        }
    }

    static fromJS(data: any): GooglePayConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new GooglePayConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["enabled"] = this.enabled;
        data["environment"] = this.environment;
        data["merchantId"] = this.merchantId;
        data["merchantName"] = this.merchantName;
        data["gateway"] = this.gateway;
        data["gatewayMerchantId"] = this.gatewayMerchantId;
        if (Array.isArray(this.allowedCardNetworks)) {
            data["allowedCardNetworks"] = [];
            for (let item of this.allowedCardNetworks)
                data["allowedCardNetworks"].push(item);
        }
        if (Array.isArray(this.allowedAuthMethods)) {
            data["allowedAuthMethods"] = [];
            for (let item of this.allowedAuthMethods)
                data["allowedAuthMethods"].push(item);
        }
        return data;
    }
}

/** Typed Google Pay configuration returned on PaymentConfigDto. Holds the merchant identity and network settings the Google Pay JS API needs to render the payment sheet. Single source of truth for both legacy tenant-level (Fiserv) and plugin-driven (Generic) flows. */
export interface IGooglePayConfigDto {
    /** True when Google Pay is offered for this tenant / plugin pair. */
    enabled: boolean;
    /** Google Pay environment - TEST or PRODUCTION. */
    environment?: string;
    /** Google Pay merchant id (e.g. BCR2DN...). */
    merchantId?: string;
    /** Merchant name shown in the Google Pay sheet. */
    merchantName?: string;
    /** PSP gateway identifier (e.g. "cardconnect"). */
    gateway?: string;
    /** PSP-specific gateway merchant id used to encrypt the token to the PSP. */
    gatewayMerchantId?: string;
    /** Allowed card networks - VISA, MASTERCARD, AMEX, DISCOVER, etc. */
    allowedCardNetworks?: string[];
    /** Allowed auth methods - PAN_ONLY, CRYPTOGRAM_3DS. */
    allowedAuthMethods?: string[];

    [key: string]: any;
}

/** Typed Apple Pay configuration returned on PaymentConfigDto. Holds the merchant identity and network settings the Apple Pay JS API needs to render the payment sheet. Single source of truth for both legacy tenant-level (Fiserv) and plugin-driven (Generic) flows. The merchant decryption certificate is plugin-side and never appears here. */
export class ApplePayConfigDto implements IApplePayConfigDto {
    /** True when Apple Pay is offered for this tenant / plugin pair. */
    enabled!: boolean;
    /** Apple Pay merchant id (e.g. merchant.com.yourbusiness). */
    merchantId?: string;
    /** Merchant name shown in the Apple Pay sheet. */
    merchantName?: string;
    /** Supported card networks - visa, masterCard, amex, discover (note lowercase). */
    supportedNetworks?: string[];
    /** Merchant capabilities - supports3DS, supportsEMV, supportsCredit, supportsDebit. */
    merchantCapabilities?: string[];

    [key: string]: any;

    constructor(data?: IApplePayConfigDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.enabled = _data["enabled"];
            this.merchantId = _data["merchantId"];
            this.merchantName = _data["merchantName"];
            if (Array.isArray(_data["supportedNetworks"])) {
                this.supportedNetworks = [] as any;
                for (let item of _data["supportedNetworks"])
                    this.supportedNetworks!.push(item);
            }
            if (Array.isArray(_data["merchantCapabilities"])) {
                this.merchantCapabilities = [] as any;
                for (let item of _data["merchantCapabilities"])
                    this.merchantCapabilities!.push(item);
            }
        }
    }

    static fromJS(data: any): ApplePayConfigDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApplePayConfigDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["enabled"] = this.enabled;
        data["merchantId"] = this.merchantId;
        data["merchantName"] = this.merchantName;
        if (Array.isArray(this.supportedNetworks)) {
            data["supportedNetworks"] = [];
            for (let item of this.supportedNetworks)
                data["supportedNetworks"].push(item);
        }
        if (Array.isArray(this.merchantCapabilities)) {
            data["merchantCapabilities"] = [];
            for (let item of this.merchantCapabilities)
                data["merchantCapabilities"].push(item);
        }
        return data;
    }
}

/** Typed Apple Pay configuration returned on PaymentConfigDto. Holds the merchant identity and network settings the Apple Pay JS API needs to render the payment sheet. Single source of truth for both legacy tenant-level (Fiserv) and plugin-driven (Generic) flows. The merchant decryption certificate is plugin-side and never appears here. */
export interface IApplePayConfigDto {
    /** True when Apple Pay is offered for this tenant / plugin pair. */
    enabled: boolean;
    /** Apple Pay merchant id (e.g. merchant.com.yourbusiness). */
    merchantId?: string;
    /** Merchant name shown in the Apple Pay sheet. */
    merchantName?: string;
    /** Supported card networks - visa, masterCard, amex, discover (note lowercase). */
    supportedNetworks?: string[];
    /** Merchant capabilities - supports3DS, supportsEMV, supportsCredit, supportsDebit. */
    merchantCapabilities?: string[];

    [key: string]: any;
}

/** Status of a payment. */
export enum PaymentStatusEnumDto {
    PreProcessing = "PreProcessing",
    Processing = "Processing",
    Processed = "Processed",
    ProcessingFailed = "ProcessingFailed",
    Failed = "Failed",
    Posting = "Posting",
    Posted = "Posted",
    PostingFailed = "PostingFailed",
    PendingReview = "PendingReview",
    Cancelled = "Cancelled",
    Refunded = "Refunded",
    Finalized = "Finalized",
}

/** Supported payment method types */
export enum PaymentMethodTypeEnumDto {
    CreditCard = "CreditCard",
    ECheck = "ECheck",
    Undetermined = "Undetermined",
}

/** Allowed Account Types for EChecks */
export enum ECheckAccountTypeEnumDto {
    Checking = "Checking",
    Savings = "Savings",
}

/** Allowed Account Ownership Types for EChecks */
export enum ECheckAccountOwnerTypeEnumDto {
    Personal = "Personal",
    Business = "Business",
}

/** User's affirmative consent to a specific authorization-text version, sent from the frontend to the backend on payment-method save, ad-hoc pay, and scheduled-payment creation submits (TOP-2935 / NACHA compliance). Consent is captured as inline clickwrap: the authorization text is shown on the page and the user consents by clicking the primary submit button. The presence of this object IS the consent act — there is no separate "given" flag. Omitted entirely from the request when the frontend resolved no active authorization text via the credit-AdHoc fallback chain (legitimate only for Credit-card flows where the tenant has not configured any text). For ECheck flows the server REQUIRES this object regardless of what the frontend sends. */
export class AuthorizationConsentDto implements IAuthorizationConsentDto {
    /** Id of the AuthorizationTextVersion the user believes they consented to. */
    versionId!: number;
    /** Exact text the user saw at consent time. Hashed (sha256 over normalized
text) on the server and compared to the stored hash on the referenced
version; a mismatch indicates DOM tampering or transport corruption.
 */
    text!: string;

    [key: string]: any;

    constructor(data?: IAuthorizationConsentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.versionId = _data["versionId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): AuthorizationConsentDto {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizationConsentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["versionId"] = this.versionId;
        data["text"] = this.text;
        return data;
    }
}

/** User's affirmative consent to a specific authorization-text version, sent from the frontend to the backend on payment-method save, ad-hoc pay, and scheduled-payment creation submits (TOP-2935 / NACHA compliance). Consent is captured as inline clickwrap: the authorization text is shown on the page and the user consents by clicking the primary submit button. The presence of this object IS the consent act — there is no separate "given" flag. Omitted entirely from the request when the frontend resolved no active authorization text via the credit-AdHoc fallback chain (legitimate only for Credit-card flows where the tenant has not configured any text). For ECheck flows the server REQUIRES this object regardless of what the frontend sends. */
export interface IAuthorizationConsentDto {
    /** Id of the AuthorizationTextVersion the user believes they consented to. */
    versionId: number;
    /** Exact text the user saw at consent time. Hashed (sha256 over normalized
text) on the server and compared to the stored hash on the referenced
version; a mismatch indicates DOM tampering or transport corruption.
 */
    text: string;

    [key: string]: any;
}

/** Digital wallet flavor for a wallet-originated payment. Mirrors the backend `DigitalWalletType` domain enum on the wire as a string (NSwag-style string enum) so the same generated type is reusable across portals. */
export enum DigitalWalletTypeEnumDto {
    GooglePay = "GooglePay",
    ApplePay = "ApplePay",
}

/** Hidden form input for a redirect-style payment handoff */
export class RedirectFormInputDto implements IRedirectFormInputDto {
    /** HTML form input name */
    name?: string;
    /** HTML form input value, potentially containing preset tokens (e.g. {paymentIdentifier}) to be resolved on the client */
    value?: string;

    [key: string]: any;

    constructor(data?: IRedirectFormInputDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.name = _data["name"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): RedirectFormInputDto {
        data = typeof data === 'object' ? data : {};
        let result = new RedirectFormInputDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["name"] = this.name;
        data["value"] = this.value;
        return data;
    }
}

/** Hidden form input for a redirect-style payment handoff */
export interface IRedirectFormInputDto {
    /** HTML form input name */
    name?: string;
    /** HTML form input value, potentially containing preset tokens (e.g. {paymentIdentifier}) to be resolved on the client */
    value?: string;

    [key: string]: any;
}

/** Active authorization-text version data returned to the frontend for display at consent time. Returned by GET /authorization-text/active for the requested (paymentMethodType, authorizationType); also echoed inline in error responses when a stale-version rejection happens, so the consent component can re-render onto the new active version without a full page refresh. */
export class ActiveAuthorizationTextDto implements IActiveAuthorizationTextDto {
    /** Id of the active AuthorizationTextVersion. */
    versionId!: number;
    /** Exact text to display to the user. The client must echo this verbatim
back on the consent submission so the server can hash-compare against
its stored hash.
 */
    text!: string;

    [key: string]: any;

    constructor(data?: IActiveAuthorizationTextDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.versionId = _data["versionId"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): ActiveAuthorizationTextDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveAuthorizationTextDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["versionId"] = this.versionId;
        data["text"] = this.text;
        return data;
    }
}

/** Active authorization-text version data returned to the frontend for display at consent time. Returned by GET /authorization-text/active for the requested (paymentMethodType, authorizationType); also echoed inline in error responses when a stale-version rejection happens, so the consent component can re-render onto the new active version without a full page refresh. */
export interface IActiveAuthorizationTextDto {
    /** Id of the active AuthorizationTextVersion. */
    versionId: number;
    /** Exact text to display to the user. The client must echo this verbatim
back on the consent submission so the server can hash-compare against
its stored hash.
 */
    text: string;

    [key: string]: any;
}

export class ErrorDto implements IErrorDto {
    /** Error message to display to the user */
    errorMessage!: string;
    /** Random number to help correlate the error log with what the user sees.
Prefix "S" is for Server error; "C" is for Client error.
 */
    errorNumber!: string;
    /** Error def identifying the error */
    errorDef!: string;
    /** Error details for troubleshooting/development */
    errorDetails?: string;
    /** Prompt the user with a modal dialog with this message. */
    prompt?: boolean;
    /** For `errorDef = "AuthorizationVersionStale"` rejections only: the new
currently-active authorization text. The consent component re-renders
onto this version inline (deviation #4), allowing the user to re-confirm
without losing other form state. Absent for all other error responses. */
    activeAuthorizationText?: ActiveAuthorizationTextDto;

    [key: string]: any;

    constructor(data?: IErrorDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.errorMessage = _data["errorMessage"];
            this.errorNumber = _data["errorNumber"];
            this.errorDef = _data["errorDef"];
            this.errorDetails = _data["errorDetails"];
            this.prompt = _data["prompt"];
            this.activeAuthorizationText = _data["activeAuthorizationText"] ? ActiveAuthorizationTextDto.fromJS(_data["activeAuthorizationText"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ErrorDto {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["errorMessage"] = this.errorMessage;
        data["errorNumber"] = this.errorNumber;
        data["errorDef"] = this.errorDef;
        data["errorDetails"] = this.errorDetails;
        data["prompt"] = this.prompt;
        data["activeAuthorizationText"] = this.activeAuthorizationText ? this.activeAuthorizationText.toJSON() : <any>undefined;
        return data;
    }
}

export interface IErrorDto {
    /** Error message to display to the user */
    errorMessage: string;
    /** Random number to help correlate the error log with what the user sees.
Prefix "S" is for Server error; "C" is for Client error.
 */
    errorNumber: string;
    /** Error def identifying the error */
    errorDef: string;
    /** Error details for troubleshooting/development */
    errorDetails?: string;
    /** Prompt the user with a modal dialog with this message. */
    prompt?: boolean;
    /** For `errorDef = "AuthorizationVersionStale"` rejections only: the new
currently-active authorization text. The consent component re-renders
onto this version inline (deviation #4), allowing the user to re-confirm
without losing other form state. Absent for all other error responses. */
    activeAuthorizationText?: ActiveAuthorizationTextDto;

    [key: string]: any;
}

export class PaymentIntegrationException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isPaymentIntegrationException = true;

    static isPaymentIntegrationException(obj: any): obj is PaymentIntegrationException {
        return obj.isPaymentIntegrationException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new PaymentIntegrationException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}